import { HubbleConfig } from '../models';
import { PublicKey } from '@solana/web3.js';

export const HUBBLE_CONFIGS: HubbleConfig[] = [
  {
    cluster: 'mainnet-beta',
    kamino: {
      mints: [
        { address: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'), scopeToken: 'USDH' },
        { address: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'), scopeToken: 'USDC' },
        { address: new PublicKey('So11111111111111111111111111111111111111112'), scopeToken: 'SOL' },
        { address: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'), scopeToken: 'MSOL' },
        { address: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'), scopeToken: 'STSOL' },
        { address: new PublicKey('Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'), scopeToken: 'USDT' },
        { address: new PublicKey('5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm'), scopeToken: 'scnSOL' },
        { address: new PublicKey('9iLH8T7zoWhY7sBmj1WK9ENbWdS1nL8n9wAxaeRitTa6'), scopeToken: 'USH' },
        { address: new PublicKey('7kbnvuGBxxj8AG9qp8Scn56muWGaRaFqxg1FsRp3PaFT'), scopeToken: 'UXD' },
        { address: new PublicKey('7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn'), scopeToken: 'JSOL' },
        { address: new PublicKey('DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ'), scopeToken: 'DUST' },
        { address: new PublicKey('USDrbBQwQbQ2oWHUPfA8QBHcyVxKUq1xHyXsSLKdUq2'), scopeToken: 'USDR' },
        { address: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'), scopeToken: 'ETH' },
        { address: new PublicKey('9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E'), scopeToken: 'BTC' },
        { address: new PublicKey('HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6'), scopeToken: 'HBB' },
        { address: new PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn'), scopeToken: 'JITOSOL' },
        { address: new PublicKey('4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R'), scopeToken: 'RAY' },
        { address: new PublicKey('DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263'), scopeToken: 'BONK' },
        { address: new PublicKey('7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU'), scopeToken: 'SAMO' },
        { address: new PublicKey('LAinEtNLgpmCP9Rvsf5Hn8W6EhNiKLZQti1xfWMLy6X'), scopeToken: 'LaineSOL' },
        { address: new PublicKey('bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1'), scopeToken: 'bSOL' },
        { address: new PublicKey('BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn'), scopeToken: 'HADES' },
        { address: new PublicKey('orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE'), scopeToken: 'ORCA' },
        { address: new PublicKey('EjmyN6qEC1Tf1JxiG1ae7UTJhUxSwk1TCWNWqxWV4J6o'), scopeToken: 'DAI' },
        { address: new PublicKey('5PmpMzWjraf3kSsGEKtqdUsCoLhptg4yriZ17LKKdBBy'), scopeToken: 'HDG' },
        { address: new PublicKey('HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p'), scopeToken: 'LDO' },
        { address: new PublicKey('MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey'), scopeToken: 'MNDE' },
        { address: new PublicKey('ratioMVg27rSZbSvBopUvsdrGUzeALUfFma61mpxc8J'), scopeToken: 'RATIO' },
        { address: new PublicKey('5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm'), scopeToken: 'SCNSOL' },
        { address: new PublicKey('UXPhBoR3qG4UCiGNJfV7MqhHyFqKN68g45GoYvAeL2M'), scopeToken: 'UXP' },
        { address: new PublicKey('C7RpHABBJjfkmizgnR2MRbpfEF454Rb18XC6RmBC8cGg'), scopeToken: 'kSOLSTSOLOrca' },
        { address: new PublicKey('5BmZgW7dk1kximGfn7MPvDigp3yRmgT64jS9Skdq4nPY'), scopeToken: 'kUSDHUSDCOrca' },
        { address: new PublicKey('3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh'), scopeToken: 'wBTC' },
        { address: new PublicKey('RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a'), scopeToken: 'RLB' },
        { address: new PublicKey('CgnTSoL3DgY9SFHxcLj6CgCgKKoTBr6tp4CPAEWy25DE'), scopeToken: 'CGNTSOL' },
        { address: new PublicKey('HxhWkVpk5NS4Ltg5nij2G671CKXFRKPK8vy271Ub4uEK'), scopeToken: 'HXRO' },
        { address: new PublicKey('A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM'), scopeToken: 'USDCet' },
        { address: new PublicKey('hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux'), scopeToken: 'HNT' },
        { address: new PublicKey('mb1eu7TzEc71KxDpsmsKoucSSuuoGLv1drys1oP2jh6'), scopeToken: 'MOBILE' },
        { address: new PublicKey('iotEVVZLEywoTn1QdwNPddxPWszn3zFhEot3MfL9fns'), scopeToken: 'IOT' },
      ],
      whirlpoolsToSnapshot: [
        {
          address: new PublicKey('5Z66YYYaTmmx1R4mATAGLSc8aV4Vfy5tNdJQzk1GP9RF'),
          collateralA: 'ORCA',
          collateralB: 'USDC',
          mintA: new PublicKey('orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('HJPjoWUrhoZzkNfRpHuieeFk9WcZWjwy6PBjZ81ngndJ'),
          collateralA: 'SOL',
          collateralB: 'USDC',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('AiMZS5U3JMvpdvsr1KeaMiS354Z1DeSg5XjA4yYRxtFf'),
          collateralA: 'MSOL',
          collateralB: 'USDC',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('HQcY5n2zP6rW74fyFEhWeBd3LnJpBcZechkvJpmdb8cx'),
          collateralA: 'SOL',
          collateralB: 'MSOL',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
        },
        {
          address: new PublicKey('7A1R3L7AxcxuZHMJjFgskKGeBR5Rwst3Ai5bv5uAWZFG'),
          collateralA: 'MSOL',
          collateralB: 'USDT',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'),
        },
        {
          address: new PublicKey('AXtdSZ2mpagmtM5aipN5kV9CyGBA8dxhSBnqMRp7UpdN'),
          collateralA: 'STSOL',
          collateralB: 'USDC',
          mintA: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('2AEWSvUds1wsufnsDPCXjFsJCMJH5SNNm7fSF4kxys9a'),
          collateralA: 'SOL',
          collateralB: 'STSOL',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
        },
        {
          address: new PublicKey('FAbwB8VgdgSGty5E8dnmNbu5PZnQcvSuLnboJVpw1Rty'),
          collateralA: 'STSOL',
          collateralB: 'USDT',
          mintA: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
          mintB: new PublicKey('Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'),
        },
        {
          address: new PublicKey('E5KuHFnU2VuuZFKeghbTLazgxeni4dhQ7URE4oBtJju2'),
          collateralA: 'ETH',
          collateralB: 'USDC',
          mintA: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('ErSQss3jrqDpQoLEYvo6onzjsi6zm4Sjpoz1pjqz2o6D'),
          collateralA: 'BTC',
          collateralB: 'USDC',
          mintA: new PublicKey('9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('6jZQFLhSAzTYfo33MSQYvwKvZYwxat8kUa29Mz63oHN9'),
          collateralA: 'MSOL',
          collateralB: 'ETH',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
        },
        {
          address: new PublicKey('H1fREbTWrkhCs2stH3tKANWJepmqeF9hww4nWRYrM7uV'),
          collateralA: 'MSOL',
          collateralB: 'BTC',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E'),
        },
        {
          address: new PublicKey('9vqYJjDUFecLL2xPUC4Rc7hyCtZ6iJ4mDiVZX7aFXoAe'),
          collateralA: 'SAMO',
          collateralB: 'USDC',
          mintA: new PublicKey('7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('J7qn7AvZ4QK9qT6BikVBKA3hUp89Lg9UkqJmXZQEjRxq'),
          collateralA: 'STSOL',
          collateralB: 'BTC',
          mintA: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
          mintB: new PublicKey('9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E'),
        },
        {
          address: new PublicKey('Db4AyCBKyH5pcCxJuvQzWfFsVsSH6rM9sm21HbA4WU5'),
          collateralA: 'STSOL',
          collateralB: 'ETH',
          mintA: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
          mintB: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
        },
        {
          address: new PublicKey('ApLVWYdXzjoDhBHeRx6SnbFWv4MYjFMih5FijDQUJk5R'),
          collateralA: 'USH',
          collateralB: 'USDC',
          mintA: new PublicKey('9iLH8T7zoWhY7sBmj1WK9ENbWdS1nL8n9wAxaeRitTa6'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('GpqMSH1YM6oPmJ5xxEE2KfePf7uf5rXFbTW2TnxicRj6'),
          collateralA: 'USDH',
          collateralB: 'STSOL',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
        },
        {
          address: new PublicKey('Fvtf8VCjnkqbETA6KtyHYqHm26ut6w184Jqm4MQjPvv7'),
          collateralA: 'USDH',
          collateralB: 'USDC',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('F7qyox3dAegTNfd8oBQD97LuCHWzQ9hSjbsF7Kv8kTNc'),
          collateralA: 'ABR',
          collateralB: 'USDC',
          mintA: new PublicKey('a11bdAAuV8iB2fu7X6AxAvDTo1QZ8FXB3kk5eecdasp'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('8Ej6U2za4nwsCUyEXidzG9aWcd69PPtrA3hnVYWgJUx1'),
          collateralA: 'SOL',
          collateralB: 'JSOL',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn'),
        },
        {
          address: new PublicKey('HPh1hkQFYchT3bfeYQTx4uLRXuj7eRMjdJZJjtRY6gDq'),
          collateralA: 'CMFI',
          collateralB: 'USDC',
          mintA: new PublicKey('5Wsd311hY8NXQhkt9cWHwTnqafk7BGEbLu8Py3DSnPAr'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('xLeM685ZkAZYXDKwzfB9eyszw1oELAmzCn45amKscmh'),
          collateralA: 'MEAN',
          collateralB: 'USDC',
          mintA: new PublicKey('MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('2fPqLazJ91cKRoZoH9XHC2YQnRq2wBZZpbcNx4HYoQXY'),
          collateralA: 'STEP',
          collateralB: 'USDH',
          mintA: new PublicKey('StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT'),
          mintB: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
        },
        {
          address: new PublicKey('5AX84BrKDWpUZ87fbQpkm7XsSx8bWwANePRmAx17tQjM'),
          collateralA: 'SOL',
          collateralB: 'STEP',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT'),
        },
        {
          address: new PublicKey('4RGgiAMx3YED2nPTvTrVuy7u93pw9AtJBQjGJ4gLiTiz'),
          collateralA: 'KI',
          collateralB: 'USDC',
          mintA: new PublicKey('kiTkNc7nYAu8dLKjQFYPx3BqdzwagZGBUrcb7d4nbN5'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('CpbNcvqxXdQyQ3SRPDPSwLfzd9sgzBm8TjRFsfJL7Pf4'),
          collateralA: 'DUST',
          collateralB: 'USDC',
          mintA: new PublicKey('DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('CPsTfDvZYeVB5uTqQZcwwTTBJ7KPFvB6JKLGSWsFZEL7'),
          collateralA: 'SOL',
          collateralB: 'DUST',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('DUSTawucrTsGU8hcqRdHDCbuYhCPADMLM2VcCb8VnFnQ'),
        },
        {
          address: new PublicKey('4eJ1jCPysCrEH53VUAxgNT8BMccXsgHX1nX4FxXAUVWy'),
          collateralA: 'USDH',
          collateralB: 'MSOL',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
        },
        {
          address: new PublicKey('6BFWHpnQA7BTHq8XXzuPFmKiZxwH866udVVXNvMrWPqB'),
          collateralA: 'USDR',
          collateralB: 'USDT',
          mintA: new PublicKey('USDrbBQwQbQ2oWHUPfA8QBHcyVxKUq1xHyXsSLKdUq2'),
          mintB: new PublicKey('Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'),
        },
        {
          address: new PublicKey('5kDjnhGz9jjwUE84syEjUJjPyQNo4eA5uxs9fd5zzswS'),
          collateralA: 'USDR',
          collateralB: 'USDC',
          mintA: new PublicKey('USDrbBQwQbQ2oWHUPfA8QBHcyVxKUq1xHyXsSLKdUq2'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('AiZa55wSymdzwU9VDoWBrjizFjHdzDJFRNks2enP35sw'),
          collateralA: 'SOL',
          collateralB: 'USDH',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
        },
        {
          address: new PublicKey('GpVjnSuCA9rfrWS13nL1wPmzqNzqLrP5ih1vhu7yhiPv'),
          collateralA: 'USDH',
          collateralB: 'BTC',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E'),
        },
        {
          address: new PublicKey('3jLRacqwVaxLC6fSNaZSHiC7samXPkSkJ3j5d6QJUaEL'),
          collateralA: 'USDH',
          collateralB: 'ETH',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
        },
        {
          address: new PublicKey('7GZXejXCyJ3R78d71328wqMWT7Ejwu7pxxWRWvHSeVfb'),
          collateralA: 'USDH',
          collateralB: 'HBB',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6'),
        },
        {
          address: new PublicKey('AU971DrPyhhrpRnmEBp5pDTWL2ny7nofb5vYBjDJkR2E'),
          collateralA: 'ETH',
          collateralB: 'USDC',
          mintA: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('7qbRF6YsyGuLUVs6Y1q64bdVrfe4ZcUUz1JRdoVNUJnm'),
          collateralA: 'SOL',
          collateralB: 'USDC',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('Hp53XEtt4S8SvPCXarsLSdGfZBuUr5mMmZmX2DRNXQKp'),
          collateralA: 'SOL',
          collateralB: 'JITOSOL',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn'),
        },
        {
          address: new PublicKey('GgAqL1Lfs3zYZK6Gea9Bey5jmPbK8c4dmBbe5gPeYQEz'),
          collateralA: 'USDC',
          collateralB: 'JITOSOL',
          mintA: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
          mintB: new PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn'),
        },
        {
          address: new PublicKey('GGRzS8AmNmMmjiMKUKRp4BML4UurpTPh7ZbLyeGqX8LA'),
          collateralA: 'USDH',
          collateralB: 'JITOSOL',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn'),
        },
        {
          address: new PublicKey('GMx3g7HZCVzLuE6Ckdu9sgExgiZQ7kiF7xfCrPnwVzbr'),
          collateralA: 'USDH',
          collateralB: 'BONK',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263'),
        },
        {
          address: new PublicKey('3ne4mWqdYuNiYrYZC9TrA3FcfuFdErghH97vNPbjicr1'),
          collateralA: 'SOL',
          collateralB: 'BONK',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263'),
        },
        {
          address: new PublicKey('8dxebMPEZjYJvE5JfC9iicZt9pkATBLW1PFgRHi5wGGv'),
          collateralA: 'MSOL',
          collateralB: 'JITOSOL',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn'),
        },
        {
          address: new PublicKey('DpmWxsGtJoe9r5JjYT5XWN5ZDBW54echsfQBt54WEi9m'),
          collateralA: 'USDH',
          collateralB: 'SAMO',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU'),
        },
        {
          address: new PublicKey('DFNxfUy4YfAafSJBDL3cTeLDb2DPBMJ5wCxePzWujmVA'),
          collateralA: 'SOL',
          collateralB: 'SAMO',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU'),
        },
        {
          address: new PublicKey('6MSGDnvqB7qnTjXerKFyJwKUPWjNfCc9kyThR5sL8GWZ'),
          collateralA: 'bSOL',
          collateralB: 'BONK',
          mintA: new PublicKey('bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1'),
          mintB: new PublicKey('DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263'),
        },
        {
          address: new PublicKey('6MSGDnvqB7qnTjXerKFyJwKUPWjNfCc9kyThR5sL8GWZ'),
          collateralA: 'LaineSOL',
          collateralB: 'BONK',
          mintA: new PublicKey('LAinEtNLgpmCP9Rvsf5Hn8W6EhNiKLZQti1xfWMLy6X'),
          mintB: new PublicKey('DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263'),
        },
        {
          address: new PublicKey('6MSGDnvqB7qnTjXerKFyJwKUPWjNfCc9kyThR5sL8GWZ'),
          collateralA: 'LaineSOL',
          collateralB: 'JITOSOL',
          mintA: new PublicKey('LAinEtNLgpmCP9Rvsf5Hn8W6EhNiKLZQti1xfWMLy6X'),
          mintB: new PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn'),
        },
        {
          address: new PublicKey('2QK4n92cVZvAW8WjSYz4imyFECJunKHETDDu6X3w29b8'),
          collateralA: 'HADES',
          collateralB: 'USDC',
          mintA: new PublicKey('BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('H5VULAZyHVkp8E8UM4afihuoebHPjSoUberhYBXeafGU'),
          collateralA: 'HADES',
          collateralB: 'USDC',
          mintA: new PublicKey('BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('78UabsZZey1U72t8axX1vfDUTHubn7SPCEUraMiU2y8Y'),
          collateralA: 'HADES',
          collateralB: 'USDC',
          mintA: new PublicKey('BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('Aj96H3zePCQ3Z8jL5tND2BiBYTaCWcfGESkn9Sa4FF9u'),
          collateralA: 'SOL',
          collateralB: 'HADES',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn'),
        },
        {
          address: new PublicKey('DjfEf8RqbBytbq2oyG5oSrdfGYgtXhk24zgwapswNTfZ'),
          collateralA: 'SOL',
          collateralB: 'HADES',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn'),
        },
        {
          address: new PublicKey('i3Ug1L3QnDPeyUg7SzyUwSTo4GLRecVhDd1aeivirDq'),
          collateralA: 'SOL',
          collateralB: 'HADES',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn'),
        },
        {
          address: new PublicKey('5snaYowgJDfuM1LPbTNUYHbgkKHtVVnzHiiLDWUV2hh8'),
          collateralA: 'bSOL',
          collateralB: 'JITOSOL',
          mintA: new PublicKey('bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1'),
          mintB: new PublicKey('J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn'),
        },
        {
          address: new PublicKey('5snaYowgJDfuM1LPbTNUYHbgkKHtVVnzHiiLDWUV2hh8'),
          collateralA: 'SOL',
          collateralB: 'bSOL',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1'),
        },
        {
          address: new PublicKey('ABwq1ro51rdcuknyTs1M5oYqmLxY4E9eaBy19QGvpXym'),
          collateralA: 'bSOL',
          collateralB: 'BONK',
          mintA: new PublicKey('bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1'),
          mintB: new PublicKey('DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263'),
        },
        {
          address: new PublicKey('EnSJFxjoR9gXKVup6taJxjc6siLGJFmHyqrxawRq9gk5'),
          collateralA: 'SOL',
          collateralB: 'bSOL',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1'),
        },
        {
          address: new PublicKey('3EptK4R8rUDWuWMvfF7Wf23whHPSgrmfravJQXWHQ2L3'),
          collateralA: 'USDC',
          collateralB: 'HADES',
          mintA: new PublicKey('BWXrrYFhT7bMHmNBFoQFWdsSgA3yXoAnMhDK6Fn1eSEn'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('8phK65jxmTPEN158xLgSr4oZvssw9SyTErpNZj3g7px4'),
          collateralA: 'SOL',
          collateralB: 'bSOL',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1'),
        },
        {
          address: new PublicKey('AHoX7W4sjiYQnjdbMLqr4NrBMZqTyoA6QoeRdNfgDez'),
          collateralA: 'RLB',
          collateralB: 'SOL',
          mintA: new PublicKey('RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a'),
          mintB: new PublicKey('So11111111111111111111111111111111111111112'),
        },
        {
          address: new PublicKey('HwCngan6JmSxeYdizHxDLXUUi21ggoQgVPVSp9rP2Hk1'),
          collateralA: 'RLB',
          collateralB: 'SOL',
          mintA: new PublicKey('RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a'),
          mintB: new PublicKey('So11111111111111111111111111111111111111112'),
        },
        {
          address: new PublicKey('6bskSanDywHt17rRXRbnx1zoErCeCpst5P4544s6cZka'),
          collateralA: 'RLB',
          collateralB: 'USDC',
          mintA: new PublicKey('RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('DvgSQJyx6JNaPzmhBwzWw6rntGBQCr5fmNnV2AfyEfCg'),
          collateralA: 'STSOL',
          collateralB: 'MSOL',
          mintA: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
          mintB: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
        },
        {
          address: new PublicKey('max1GTEmP7zAxJSEe9jFkihYSnxZmbEbp9BtBNYw1K6'),
          collateralA: 'LDO',
          collateralB: 'STSOL',
          mintA: new PublicKey('HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p'),
          mintB: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
        },
        {
          address: new PublicKey('BVXNG6BrL2Tn3NmppnMeXHjBHTaQSnSnLE99JKwZSWPg'),
          collateralA: 'MNDE',
          collateralB: 'MSOL',
          mintA: new PublicKey('MNDEFzGvMt87ueuHvVU9VcTqsAP5b3fTGPsHuuPA5ey'),
          mintB: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
        },
        {
          address: new PublicKey('5Z66YYYaTmmx1R4mATAGLSc8aV4Vfy5tNdJQzk1GP9RF'),
          collateralA: 'ORCA',
          collateralB: 'USDC',
          mintA: new PublicKey('orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('H3bEHDH3ResiGgR8avFUEfU8rfyLzjEQbf4WR5mkXmJ9'),
          collateralA: 'MSOL',
          collateralB: 'CGNTSOL',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('CgnTSoL3DgY9SFHxcLj6CgCgKKoTBr6tp4CPAEWy25DE'),
        },
        {
          address: new PublicKey('Zko5YLwAZL1F2W13ohkG9DVAZCmYqcCqHrEgmaudmbe'),
          collateralA: 'CGNTSOL',
          collateralB: 'USDC',
          mintA: new PublicKey('CgnTSoL3DgY9SFHxcLj6CgCgKKoTBr6tp4CPAEWy25DE'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('GrXkAvh5dohLd8Va432MxW2ckthWhfw9FEGSxJHEsKg'),
          collateralA: 'USDC',
          collateralB: 'HXRO',
          mintA: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
          mintB: new PublicKey('HxhWkVpk5NS4Ltg5nij2G671CKXFRKPK8vy271Ub4uEK'),
        },
        {
          address: new PublicKey('AFCKH5AnW2inQdV3RgcLyk9PgLUhbN6Xy64pceJSwrfs'),
          collateralA: 'USDC',
          collateralB: 'HXRO',
          mintA: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
          mintB: new PublicKey('HxhWkVpk5NS4Ltg5nij2G671CKXFRKPK8vy271Ub4uEK'),
        },
        {
          address: new PublicKey('7A1R3L7AxcxuZHMJjFgskKGeBR5Rwst3Ai5bv5uAWZFG'),
          collateralA: 'MSOL',
          collateralB: 'USDT',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'),
        },
        {
          address: new PublicKey('7A1R3L7AxcxuZHMJjFgskKGeBR5Rwst3Ai5bv5uAWZFG'),
          collateralA: 'USDCet',
          collateralB: 'USDC',
          mintA: new PublicKey('A9mUU4qviSctJVPJdBJWkb28deg915LYJKrzQ19ji3FM'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('45zpzzpZquaVv4BAdXfzNbuba7DAXV32d1sTrUh5wcnW'),
          collateralA: 'HNT',
          collateralB: 'MOBILE',
          mintA: new PublicKey('hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux'),
          mintB: new PublicKey('mb1eu7TzEc71KxDpsmsKoucSSuuoGLv1drys1oP2jh6'),
        },
        {
          address: new PublicKey('FmbpZzT61ftb5pR3Rn5kgerLRvFzKicc7aCj4Zaes5E9'),
          collateralA: 'MOBILE',
          collateralB: 'USDC',
          mintA: new PublicKey('mb1eu7TzEc71KxDpsmsKoucSSuuoGLv1drys1oP2jh6'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('FMFVwK5TXbKb6Q9LVxN445fisLdZHNSL4wfRSCMrBpay'),
          collateralA: 'MOBILE',
          collateralB: 'USDC',
          mintA: new PublicKey('mb1eu7TzEc71KxDpsmsKoucSSuuoGLv1drys1oP2jh6'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('6x6FPHbG1igaDCJ57UScYxg1sFjevhMNaW9md9PfudFx'),
          collateralA: 'HNT',
          collateralB: 'IOT',
          mintA: new PublicKey('hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux'),
          mintB: new PublicKey('iotEVVZLEywoTn1QdwNPddxPWszn3zFhEot3MfL9fns'),
        },
        {
          address: new PublicKey('6CgjHrdiQXDZMXL8BjUFMH6fq4tzWtPBGMB4tTWbDy6s'),
          collateralA: 'HNT',
          collateralB: 'IOT',
          mintA: new PublicKey('hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux'),
          mintB: new PublicKey('iotEVVZLEywoTn1QdwNPddxPWszn3zFhEot3MfL9fns'),
        },
        {
          address: new PublicKey('HoSnxZhcLASeHt1rirASizonYoCcBszHHFaF1Z8cvncA'),
          collateralA: 'USDH',
          collateralB: 'HNT',
          mintA: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
          mintB: new PublicKey('hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux'),
        },
      ],
      raydiumPoolsToSnapshot: [
        {
          address: new PublicKey('3tD34VtprDSkYCnATtQLCiVgTkECU3d12KtjupeR6N2X'),
          collateralA: 'SOL',
          collateralB: 'USDC',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('HZf7wppva3wk4dCnrUe2GE1c8aUEXsUNk5asMFQ5sYch'),
          collateralA: 'SOL',
          collateralB: 'MSOL',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
        },
        {
          address: new PublicKey('CiHghAc3Fat5JgBB4L6vUcY6hud89YwgL1q4nKu1rsNQ'),
          collateralA: 'MSOL',
          collateralB: 'USDC',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('9cGUdTiSGsP9Du3NXHhkxK7fbNT4pL543yZH4bUatR1v'),
          collateralA: 'STSOL',
          collateralB: 'ETH',
          mintA: new PublicKey('7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj'),
          mintB: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
        },
        {
          address: new PublicKey('4nFbdT7DeXATvaRZfR3WqALGJnogMjqe9vf2H6C1WXBr'),
          collateralA: 'BTC',
          collateralB: 'USDC',
          mintA: new PublicKey('3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('HCfytQ49w6Dn9UhHCqjNYTZYQ6z5SwqmsyYYqW4EKDdA'),
          collateralA: 'SOL',
          collateralB: 'BTC',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh'),
        },
        {
          address: new PublicKey('3BScXnPjT4hut1G5yJ5UGQWhUmoYxyBFQf3juLBeMH2S'),
          collateralA: 'BTC',
          collateralB: 'ETH',
          mintA: new PublicKey('3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh'),
          mintB: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
        },
        {
          address: new PublicKey('61R1ndXxvsWXXkWSyNkCxnzwd3zUNB8Q2ibmkiLPC8ht'),
          collateralA: 'RAY',
          collateralB: 'USDC',
          mintA: new PublicKey('4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('Enfoa5Xdtirwa46xxa5LUVcQWe7EUb2pGzTjfvU7EBS1'),
          collateralA: 'SOL',
          collateralB: 'RAY',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R'),
        },
        {
          address: new PublicKey('Chbi4BsySNmnNB4i821eMH6TzWA9DiUx2J1oHVVTk9Dm'),
          collateralA: 'MSOL',
          collateralB: 'HBB',
          mintA: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          mintB: new PublicKey('HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6'),
        },
        {
          address: new PublicKey('2QdhepnKRTLjjSqPL1PtKNwqrUkoLee5Gqs8bvZhRdMv'),
          collateralA: 'SOL',
          collateralB: 'USDC',
          mintA: new PublicKey('So11111111111111111111111111111111111111112'),
          mintB: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        },
        {
          address: new PublicKey('EhJGjF8FSqAoJPGyR3ixzFjcUM1y64fbMZEZLEUc56XN'),
          collateralA: 'RLB',
          collateralB: 'SOL',
          mintA: new PublicKey('RLBxxFkseAZ4RgJH3Sqn8jXxhmGoz9jWxDNJMh8pL7a'),
          mintB: new PublicKey('So11111111111111111111111111111111111111112'),
        },
      ],
      strategies: [
        new PublicKey('Cfuy5T6osdazUeLego5LFycBQebm9PP3H7VNdCndXXEN'),
        new PublicKey('DJ4tLS5q566UXJRdEREBKAg9URuNoyKZWByaUu62npHC'),
        new PublicKey('ByXB4xCxVhmUEmQj3Ut7byZ1Hbva1zhKjaVcv3jBMN7E'),
        new PublicKey('D6LyYoruQkw11oDqjdNifLLEd3aWkkCgTdhMvn4pvqRv'),
        new PublicKey('98kNMp1aqWoYAaUU8m5REBAYVwhFb4aX9yoSpgq8kUFu'),
        new PublicKey('2VQaDuSqqxeX2h9dS9WgpvN6ShaBxd8JjaaWEvbmTDY1'),
        new PublicKey('BCSKhjooRRtieLs4NX92bP6q3GNyqPWC3a5wbYWfxK6Y'),
        new PublicKey('7T4LUZLjZpaRrXYrWjn4E4x2gackFnuidz6j83xDNvXW'),
        new PublicKey('FshxiQWH1kTya19d186VyCSLT8PAVKn6wpVU4wP26S2M'),
        new PublicKey('BfyQYYr2T9eJfMfq5gPXcq3SUkJSh2ahtk7ZNUCzkx9e'),
        new PublicKey('6taYeUSiNzuzQ8ys5d4TErzKRTPcqAC8Mx78RfKUoD9w'),
        new PublicKey('VF45TSF5WPAay9qy2zr1hPYgieBv7r17vYLRK6v1RmB'),
        new PublicKey('2J7zeWbFC6PxtwnwEHb8zpF62w9Xanc18ThsF3UHMtVf'),
        new PublicKey('GFaca7ca27vXofRJ3y1FtWgKwKWjn3LdCexttCsRLcvc'),
        new PublicKey('A4ufgHTe3jLzxbR6sDdrZhLxNdR1Lw2ija1uEdDFLPbX'),
        new PublicKey('CofEPsAoV6bdn7guCPHhmb5nJ1xmnhZ4Ha2zZVx14Ppb'),
        new PublicKey('BKipQNa4zGAxS2kHjvgRMyFymBXJg5wnYjiud5zdqvAS'),
        new PublicKey('HVhXUenYdGnBNwP9ZrEN43AFv2Faa9GPMgZsHALPWYoT'),
        new PublicKey('DFXL6ake3YJ7iqyM3iJEQwjPG3w55C37QS8k6SAAyXH8'),
        new PublicKey('C53jcmBve7bDeQFMShCZafNX5ok7XapJLyJscQxvsjPy'),
        new PublicKey('G2kaQU5ECRaxGVoFRB1qMYE7QCtmZLupo7ShTYyymv14'),
        new PublicKey('32QXT5qS7YmPvGu2sngFkazPvp8j3choYDwW6DT8eFnD'),
        new PublicKey('CYM2ouv2Kih73k6E76Vs15qttsz7XFqtzjo33YyvKfKL'),
        new PublicKey('5i2qShi1FdGHDPnKJVPCetTveyve5GfMngg6yb22XJ6A'),
        new PublicKey('FJBDScgmTchvBpY7DnrPwn3mQ8jGQ1SMdrGMWVesDVhB'),
        new PublicKey('4dk4RuUvpXJKTrjYqLpagQ5JPKwb5oZ43KZDE42hqVsN'),
        new PublicKey('9jn566VXtkf6SJfpwJhJyc8ycmWriTXBaGz4Y2XKQQph'),
        new PublicKey('9FMsTHZKuW1YfCqzy2wEGt58o6vbJh7G5adWokQ5ejGf'),
        new PublicKey('CBYt9Nd63Br7E1vaeiLHeCHkV8Ut56ALmxSmhuqFfo7z'),
        new PublicKey('73WsXLMrCZywN1sa7VdSW7UvxVjjrQsJygGJzKhTnGH'),
        new PublicKey('EsepQgrgTHiKJHQVnJUZ636yDDt4uqWuQweStNw8Bgch'),
        new PublicKey('8kE6dbhS4pCie8LNaeVZx7jhEcpKKewho8UYiardNaxX'),
        new PublicKey('5VwUt1yNJh3HWJvydwkDMMgdMTMw99BCqnhLvtAanfgZ'),
        new PublicKey('DM6f3WvxmW6decwhMywz89VEW65FcxWV1nxvxveH8iWC'),
        new PublicKey('6YL2hyzt639WcAZywnS9ApMBnWwQgTWyiDfb7AJDFqCJ'),
        new PublicKey('6zgPtnJkWa9JcXL9tnsrx2iaWRyjzAidigDz3mMZZ7ko'),
        new PublicKey('9d7nQMn8sVjYeM8PooVU5cQgLTgT4cX7oZX6GUUZFrEf'),
        new PublicKey('3R8wxZYtyicN8KrQtXnkgvgG4NuYW1Ra5NkepQz3Kovj'),
        new PublicKey('EvcCVFV36YvgwJzeyp4jiEu3TDfCPQP2Xu3Zwfsu4DeG'),
        new PublicKey('DcqhRqfgzgkxiamwE4uG7XGYisBt2XEn62skD3vGfKxk'),
        new PublicKey('FjZWSxXjLMQb6P64rHqCrrumJSkEWj7XvhgMaFNb4fbE'),
        new PublicKey('B3Wh2AfiYL9VDfz8nYErgKyXwBUA32YPtxfEafLhBDZE'),
        new PublicKey('4Le8QimmygEhuAyifX9ngTMXegFzsWtKJNsfv3A2qcce'),
        new PublicKey('HperM5vN34nKVwGuMmyu9SoKAVBytccNDbF9ekoQFXkw'),
        new PublicKey('4sEAHHyLytB4pszzob6rJhaNj8WXj6zsyCesMGkLvbKd'),
        new PublicKey('Dnvk55Ya5VqqigtovM5Wxk9AFrHJhn72iF5CUXBd9f3Q'),
        new PublicKey('BmkdmGUHnB2DGZduxVLV3Eo2BKupLipapCKVQTjk6Jhh'),
        new PublicKey('BviEYunJoaMkumtEX9FyWiW7coaeWALDaaXiFme5zJiW'),
        new PublicKey('4Ypy6JwmgvcZ9bNzwTmfXK51y8uj1XUHJYSKAvJVNc5g'),
        new PublicKey('DEjvZw9ZMkh1wKvUG4S1jmiqojC46ePP13kWvxAmg6hR'),
        new PublicKey('3pxDd6AJ6EwbVa4P3mGCX3qWiVmdWma4EZCP2JQ2uB62'),
        new PublicKey('HnjNekxuafTkA9xZiP73QzBQH8LmKifcWuP4ncZ7zMQV'),
        new PublicKey('8tx2ASp98JitHqQk5iUqtHtd4tAkPAmFJqXwyFtEEuUB'),
        new PublicKey('C1a6BcMVhx3uGCpdeMHN7iuLAwzmQiWv1BzBfyFgq9oj'),
        new PublicKey('233yH7imV7EXNKPgUU37tSDFYtRrDXXLUbE2uLqkZqHt'),
        new PublicKey('6zNRgnvCStERUhFAz9SWPv3PzDgT6k4vwVzmcnCQRDM4'),
        new PublicKey('A6XLLT4NREqCnzBtdMY31Z58HqMSCUMUCx2LoMmFv8wg'),
        new PublicKey('6mZtb1h9zvkcDxTzS9481pbjJedtTHbMoQicg8NZReqt'),
        new PublicKey('8TGRn1PNJVCAiqAosnAZy9i5TrwMZQskDGVhTLj3hJeL'),
        new PublicKey('CbLWjxwx6BT5PyXnYdmCX6rr2JhCtzQQwjLTN2D4m57U'),
        new PublicKey('AmRCw9xKs8jgmvcr2ETrwAAZXWC829QiaWcbgJgpBuvh'),
        new PublicKey('7Bdn78UV2Eu6kwEsu7ar4oWx6w58cyTZGSfQwXVbwQWk'),
        new PublicKey('E3kjGC76RG7KBkeYqUVLXo91muvgMmt2dTCqvA4RqFPp'),
        new PublicKey('9RC8QNFFfnQ7c6JrZNBpBDW2X2nytJL6h7gRQS8ENuQL'),
        new PublicKey('zKLfwe3XuKj3HpFn67Q5k7nMz1ZtyKr3ZKG7NoqTVW1'),
        new PublicKey('GcErgVRWQDLRmMMkNQjxZeSCYte2hFkVbLeiw6HcwZnY'),
        new PublicKey('8t2qfUx38BoasGP8V8gST1dBZNuGhV66qUHpgFNBHC8o'),
        new PublicKey('FPjFsUAvupj4FPUY8HpWj7dEqFcJUWyn193fwvYxYkTW'),
        new PublicKey('Ehic3YqbFJPioH4WEVi15syxd6PduF6G846CZJ9KrnUJ'),
        new PublicKey('Hipe568Vrn6VPBzaPZkS9iKAkLMFzmeWCS7G7w1jHZd5'),
        new PublicKey('HvdhFUvjTTm28BH3LirANFa4hoafyQkpw12Dj7D64sNb'),
        new PublicKey('JP64K4wp3pDdNUp4uP5dARaUF5stg1jpNgfFXC5ciDK'),
        new PublicKey('KKugMgpzSHKtoT7aJdYksNbB1VpcgRU8NghkjXCB4ab'),
        new PublicKey('5po2XSZvwynEiwMxApgBcx7SDqeV5oy91icjC1uPaudi'),
        new PublicKey('EEqvgDEhfWJW2sMWr1cRYddb4ixGiGnYPoCSkHEXd1KT'),
        new PublicKey('55dwiG4E7vsiZUzzffneaXZh4rsHamMTbzaEBtQQ2kLk'),
        new PublicKey('3bx7xzmxgyWaW9ptn1x7Zt1LdLXhQhiwPCVuToDVqTAq'),
        new PublicKey('Gug8wWqnDbZ21xV5qAv8aHnuyKBuJvnuyPhSuAtmPfXT'),
        new PublicKey('9sHCCWmhqLtPa4yqgDke7CNtaE9KGpUWWpni8MC4WJUU'),
        new PublicKey('6iyPtRHPdRPNfkkSWQA3jahtkgjgthfM3dwAk71nPJTJ'),
        new PublicKey('Ht3kPVGEED4sDAUALLirqU4NodNc4zbSi8WVdNAKoRKh'),
        new PublicKey('3YQnXFCTZwtL2H3MadkCBPA1NRXJkXn416psWunnZYAr'),
        new PublicKey('B8uttDQzGBz8deXh7LRNFDG6wUdxdBSQ9y2pCMPyzjBH'),
        new PublicKey('G7jTpLp3F53DJwLaqYtVsnjeG2p5d5AosBFMEK4NMcy9'),
        new PublicKey('A7e4aYqohqLr9oFFwAEbUZsBpYvKsutWxDtW3MXVhLB4'),
        new PublicKey('HXXdvkZ4RYymVWaA47Hs75X7E9B1JmsJFNRyAjvL66Hz'),
        new PublicKey('2FzPrKLsGAU9QHQG1ohjb2xgZJYQzyTzrLusqHAN2Ekg'),
        new PublicKey('EuoZcSLnXho591Uxt3mvQrtREzdnsuvNNz6WyearTNHm'),
        new PublicKey('FBp7wr3qbB7WYRX8BppqbqNy7jj2mcVFnCy9s8XeTJ9f'),
        new PublicKey('AuGGSC8opfii5X5uipnUhYpvHQCUfDUkd5Z2PWGqJqwL'),
        new PublicKey('DAqZ5XiVNwgg7AhR6kmgnz6THjGb6W72DqYSjY2tz3Du'),
        new PublicKey('4hsTKUftS75am74p1qYeJLBSbed2Tqdcb2DLtrQNqoAp'),
        new PublicKey('HZj6V8DBca1tbZJwXEJDFHoK9sG7udgC82Wu788uZupz'),
        new PublicKey('4wHQqd14L4126Em11TzdT8DLX4dHyB8drbTEdi15xk4Z'),
        new PublicKey('59h7Hpobueq5trqmH9G4A5fh4vZVY5Kw8TryMfdfWK4'),
        new PublicKey('8u5892nUCULGGmZkyimtBvVHnoGUaBKRBiqyVZtSapDV'),
        new PublicKey('88ThXKrCmt8QGX6FFmCRGvxwmfTWsrtwMeNgjEsggE7W'),
        new PublicKey('kkA4gzNEn52u4LrDSWS4jPBrooV2qziM6g2iG5rs7kq'),
        new PublicKey('BjdSuiqJBeuJeBRZtidZUMJJbBMNpEptGaC6HRM4SuwN'),
        new PublicKey('8uSeb2xNPBtennNiLP5ELvU4djfyw6n2zDSgD7ZtyC9y'),
        new PublicKey('HyPDBuHnXaFkrhE1da3YULrC4fFxUN6TEa9B7xhvFpmN'),
        new PublicKey('8eoYZJccX2cju4oWnLD46V3n5tDmWpEbPZm75aiF33SV'),
        new PublicKey('BjHxRgqCB6KJ6eoYBeVDtDFJrwrg5hfgCeEHHaP5Raba'),
        new PublicKey('3qwa9ApkT9E7DtCZkYTCURE3fg1g8jwaQpuhuNwzAAfx'),
        new PublicKey('7XZQQL11KsMPafyqmyKvUuzSQVd4Bvkf2iPJn8hGGKjU'),
        new PublicKey('89LNNaDTwq65CXhmtGEYe4erWi7f1qMQ87xhpiCBazU2'),
        new PublicKey('CYLt3Bs51QT3WeFhjtYnPGZNDzdd6SY5vfUMa86gT2D8'),
        new PublicKey('HoqXSSbQGZS8o6fTqtfn9d14FVCm9WiuRB13zbHNKs7d'),
        new PublicKey('7KqB3vRJQDdGwK7ewiDpAxXpTeMmgGicdDdbftQH41XC'),
        new PublicKey('9zBNQtnenpQY6mCoRqbPpeePeSy17h34DZP82oegt1fL'),
        new PublicKey('3w1MiUh6Nn4YJLue8Ut8uwonKvFupLKve9nifDaicBf2'),
        new PublicKey('G28LWfC5F8fCtqukagwmdAt9myJXuXCvDBXZtCy2J4r8'),
        new PublicKey('8wk3Y4jAy7S56zHhC2F16nrFhJmv2QmwPyfPdWVbedbK'),
        new PublicKey('Agz8ExDrjd7UqjACotmw6XhKgXsjhnufza9Nfn6C7Ktx'),
        new PublicKey('4upkN3v9KnwxAD4aj64nTPynAS45ccSBnKns6qo6yeRu'),
        new PublicKey('F3v6sBb5gXL98kaMkaKm5GfEoBNUaSd3ZGErbjqgzTho'),
        new PublicKey('5QKrn6Eua5EgmGdSTn8nEUa3dcZx2tHEYBv6AkPetojE'),
        new PublicKey('TZ3LFwCT9mTj1h31tvGcjszS8xAoSZYTx81XTSpBaEL'),
        new PublicKey('81h4VfGfbZE8xFB2JpWeLKpAw9YKyJjwCrBC7WQ4yvw6'),
        new PublicKey('4WRpV94hyhzRBcCqVyky7UdXCCRWVoUCQUGmoThduvfL'),
        new PublicKey('5EfeGn1h7m6Rx9mGEmamDoxMtdhRmUh2N9fYRiDQqteS'),
        new PublicKey('AmjRKyaLCFJFa7U9axraV9bPW5prcWYe84j6LkvfMKtS'),
        new PublicKey('8NP2J7q6swBkVoLDZAqkejKPQrWkRizZHaVVM897CKpA'),
        new PublicKey('HCntzqDU5wXSWjwgLQP5hqh3kLHRYizKtPErvSCyggXd'),
        new PublicKey('GwfjL2jQugK7sJdhMDj7tcGuqxi5H1qAZHubfFL8amNJ'),
        new PublicKey('F8dVvsYwQciqe9CRuiUDUgEtqjiZm1DT93fnE67f1KsM'),
        new PublicKey('8jenQV2vi7EVTLW11rnUaoeYnr8KabEBZmxAAeoZMPSQ'),
        new PublicKey('FtRQ5X7vAwzZPaMzMW22tSUKrWXjqsMY1KZzhW4qfMF3'),
        new PublicKey('Hv8QW2UxK4DLtg8dJixQwWHR4nhkimMMDuqJmjJcim1m'),
        new PublicKey('8vbhUqcft4m2PzBmEntBzyWEo9dH7uxqzbDBbTJfe1rr'),
        new PublicKey('75kopyQAEro5GdUDDmthdUK6oMKJ7z8oeezXduVvJu9D'),
        new PublicKey('2U18NpPb8W6m4fgxgzXx6FLueQ3SGn3LGh2QnzvCXcHs'),
        new PublicKey('4Hm233wZuhkPEJcEvZfcmVQV1nrhP7RmmpRZgvMCTmNM'),
        new PublicKey('FxBe7AxKQQNCKDzkMzbpCmtnhDPmnTavfRqHeii8EmvW'),
        new PublicKey('E7K2S9qhypk9S1EaGKWaXyN9rP2RmPPmwHKWGQuVZHNm'),
        new PublicKey('GGmL7gXP1EKwwagMY6c4nBbypiUkVVvRrAt51FJafynQ'),
        new PublicKey('BXQEJ1xWEAxSiixRVMCdyAM9s2NypCkBuN88WQMHxcCE'),
        new PublicKey('8dahx59u8Xq79VZQkujJQHsQ5JzHTTjAJGZqKPiqsFbA'),
        new PublicKey('8YMXFERNrQ1gJbzhZKWjnebnKPpUPGQoJDKbWKymU1SL'),
        new PublicKey('6dWMu9iNNuBLpm4bnPdB5gtAPHUnhrcWconsoRoP6Ttt'),
        new PublicKey('E52WMjRwax2B2ZXABjZUt6xZquCMQgXAuErSs7j6RGS4'),
        new PublicKey('87tynGCmaM9FUzE8QT1ENSXPhPNJFv5mTkrPuGvgc9x7'),
        new PublicKey('GQvawguCeqAGVww8e2rVn9iJw31fG5AY1bVh2ftiic9J'),
        new PublicKey('8KV2ZPhiD4AgHBNow4bkgk2i7gh8WJrZBAUaXwtSA1De'),
        new PublicKey('8YqBPENiMne3kEeKSJfPsrusvjDveiuawd91Afj4MAQS'),
        new PublicKey('BaEVFsux7SerrsUxzb9y4pm14BMoE5eQNc1SCSPPeAq7'),
        new PublicKey('EQZHYCWwiaCHCPfSKohfWfmmHtJ7RW3mk5ZogbDmZuBW'),
        new PublicKey('GNBK4kfVPfjLecXReJD3rmAjeSgUnKNvAiiBKWxdMSc6'),
        new PublicKey('DchrvcBg9kqWAqC2ziQRMcxsqSoHY7fJygRTMeUz9a5P'),
        new PublicKey('ArE62nhfci2x1eHnTDAd76Z4ok7t9ywy8P9BhwoJU3jb'),
        new PublicKey('BTeVjJCb1nYLEytsqiiY9nkwqaSsLzVoWrkDu5h994no'),
        new PublicKey('3CaSWZVdWWwaYdef3GqRYYhs6Pbz1Ye8MqcLUqteQcSo'),
        new PublicKey('5RD9AXADJfwkcj39WTePLs8GYyx7A874nvXSShXxSKgK'),
        new PublicKey('FvxU7ftZu4VgtLi5nP5JbzuyqevaxR6jvgv7UPbHNHbn'),
        new PublicKey('AKtWUmeVHL8KLVTyikPfqAWpwnUV89BJLti9v8nbTBzg'),
        new PublicKey('4h6EPQ2DmpPqjVPJWCDza42UZC1CxjVSymRghZfwWieT'),
        new PublicKey('493Bxf1L3TjNpSoRw2pcakhRyXeTYha9K6CGBwHZr7zC'),
        new PublicKey('DSv8ey82ahkqjqMMykbNkGXfsCVvPch6X2JeazsHhYsV'),
        new PublicKey('2fGnnDF3BwkRFhQLQzpUWMVHVcdmH9cEQihWZ29NUpNW'),
        new PublicKey('DktbtdJHuDnXkZgMuV7Kai87CNqQBmAfjij7WA7MDcR9'),
        new PublicKey('9oTss5uEEjYnvNYEFjSiMvqrH5TGmLtZjdwpjiVWQEyv'),
        new PublicKey('6M8z6aQdeLtrwiSK4AkMhabyRpq3KrGkzwXhuBo5Zey6'),
        new PublicKey('BLcPbyo9yzhVHxPtjHcgN5Nm1ksG2W7915P6FWW8LZ3b'),
        new PublicKey('H8PBwav5aUYBz1Ne5T7nDBKsouBfaoHdfRc5UJwT5Ag5'),
        new PublicKey('7JvdArAkW8RBWTu9hxA9CLb4gHbMgNpT6uzd1EqKPLKT'),
        new PublicKey('BXa1S3U2nY8dWXJYXWHgD8zU186HvKQkpTFhUBRqVVWf'),
        new PublicKey('9Ai4GBV4S6GhGe7ckFrfgo7Px8dDHtUEgXs7Nqa55RdD'),
        new PublicKey('6nj5N2Nrmt1kXNa1rcj2cCER8weu1a3g3qPskuCm8gfW'),
        new PublicKey('7FoZBdnghZgpYLp3EWDFzte6pQiPaQLMgw2XbBHuZbeM'),
        new PublicKey('4wbXr6BhEVGa7edNipTJq3GxHg4zLmVgcAUsfBmTxTHr'),
        new PublicKey('2m2BzYQYFRUP2WitXAC4wa8H9zN4qsV197gcdno59Qfe'),
        new PublicKey('4qzbc1TH2VCDyjk1PK6WdrW1CDRiXyBoy2xfgt1Ff5kT'),
        new PublicKey('61EjRY8cNK81btuYw5VsnCzD63bmFb4d6tWGZbWVNmPr'),
        new PublicKey('12iZna9cRnhSY85cDTvas3mav36bYE9WeDuL9uFzH2Zw'),
        new PublicKey('Mpxtgfv19XStXoZYmaGLziQqw2LxAY8txABU6A8cRNE'),
        new PublicKey('DXESfdikAgtzbq8JQoQyiGRTGT5nPL7aXBSoYL3T8cjo'),
        new PublicKey('UCdb2euhoW672rDsPgRN1es3nSn7BGvKfvFVrLc3xUc'),
        new PublicKey('AMxoX3u5R6Ni1pZEvXJ9qbswhAdPKCo7gF29G5Vis5ft'),
        new PublicKey('jwCXPTY4reNNvbKmTE1YAVZ4ZUvy3ozhLMt8fbPikvY'),
        new PublicKey('Cbgo7WrxWW46cy49TzxhzpoJVcCzEd8r6pVWJFiiPkTL'),
        new PublicKey('H7gU74WroNC6DLHBywHTWEnfEsamxLiUn66uRpYueEPA'),
        new PublicKey('FC6yGPRKoeJz8iVPgvUjyzuie5sBa3FLhuP2tfdNfBpa'),
        new PublicKey('HWg7yB3C1BnmTKFMU3KGD7E96xx2rUhv4gxrwbZLXHBt'),
        new PublicKey('8XgX1EkSHC43mwdaUCZeXL2JVFz15JJynFrcxrQa3jss'),
        new PublicKey('CKGQS4pncGsBZUcp5SwTJBch3PbNchkzo74B8rT1ftaw'),
        new PublicKey('DEJkEMwVuy8c1y6xJ3TgiCEwMKox8uP3CQPtnnothmNr'),
        new PublicKey('8yDtTni74G9yTanRTgZmgmJQqigpSczpXeyTvJJauf1N'),
        new PublicKey('H8vjB9c818uxCYytMcQbabHaWKdRXcrKcKXhvPJGNKB3'),
        new PublicKey('FrXU5FSxdABjXugKNhmcaVbsc2gi5K8Xxdu262wsfo7r'),
        new PublicKey('4pSBscwxa6qmeiy3UMfLgW9t1akj18eY4hQC9wTkeb7C'),
        new PublicKey('684Nbg5uSCy1RsdomNEHH1JZNvdxgyfzjWhe2TRyXrUa'),
        new PublicKey('6dVR2NQ1M97X5onE1Senjyy3aRZZ5PSxUvbWWSmLNQsU'),
        new PublicKey('9LtLV3PreTYAXz7MPcg4ZgSu923zFdJXkD7TA5TqhFKy'),
        new PublicKey('Hqaim4KaeXSrC9rUQC7on4eBX8UguLY4dYSb7VmtFARB'),
        new PublicKey('3BSZDisLFynSVtLTbRnL8ozGJAHr7tyvH4kaJRQYunWc'),
        new PublicKey('EWzFK2LZKHvnWMYaGa6YvhHkAW6CptPQ3CCYkVgmAaXK'),
        new PublicKey('7ceDYDQvEoyq2i9m3haFjWAtfgcUg6qWpihCXoTsDDXu'),
        new PublicKey('AjBqzzHKQ7QXukKYXxuzRCDsbRGcSJyCxjVmREXgkBMN'),
        new PublicKey('GscnFgC7WLpgcg8Mop3bX6g7jRvwaQ2BUa564pdimwUW'),
        new PublicKey('C13WaZzdiJbgyWcea77qzBfKKvoyVwTCXYPMJpHYJPHK'),
        new PublicKey('66LhxPt4AKJcY7HveisJcPEhtC8SKwS3JeDYfSswV2hJ'),
        new PublicKey('ExhJyCcuyztviV1azRwNntknGXEN67JFWYXxYdNAM8f6'),
        new PublicKey('HYVCvwo9ziMCxB2zkAhfwPDTj6mrx2tVHX47iEFsho8M'),
        new PublicKey('46HF3cV4JBkbPbiT6HsXMkBh9qLsmifLzt8F8iNcPdnv'),
        new PublicKey('BX3pVJpJqLmwaLGhboDm1uLKnvk2m3Xfd8z1doT93jmb'),
        new PublicKey('frAcfwyZKKVemA3pAS7E97UiX82AqMkCn56TnVuBWjL'),
        new PublicKey('AKxzCUr6DVKqWUbcs3CkmBFXA2Zb1WQypEd9P7CmeJ9R'),
        new PublicKey('DA7BoZkoW4ipPv2Eyo5X9C5N1sZbZCXtsxjZf5oiXeyn'),
        new PublicKey('GxtrhNXMhujdpL89upXKJoWTzYNup2wmvVtcfW5w5vCP'),
        new PublicKey('24kpdg4PUZtfgiX6QNd9fJ5N4SHKQ7thHCeQH4wVBqMA'),
        new PublicKey('AuGcMJudAZJToBw6J1gMjjwwnbgcns88RNEoHUKBmSjY'),
        new PublicKey('3naDtkh65JJuduEEf2jtUaSkbn5T3XRM9kKFWDDVKZUe'),
        new PublicKey('DJk2hmmSTVouCooFEzzVzJr1DG9cXtaxz6T5rVbKABZe'),
        new PublicKey('3cYLhMVrfJWuf6kD8sF9PcrKT9duXUNcnNV6Z1LCJcxH'),
        new PublicKey('9DBkyNa3vRx8dPqjEEohmCFP3SuFiGYmeNiWMvBpfMCU'),
        new PublicKey('8bPXpgGxdaiys9gnJboDva8Baujn4K8pjE4jZ1Bo3QCS'),
        new PublicKey('7ypH9hpQ6fLRXCVdK9Zb6zSgUvzFp44EN7PWfWdUBDb5'),
        new PublicKey('5FRS6gW5Fb63AiBxF3rtYrn52Sv8GLrkp2R9cH9ppZQm'),
        new PublicKey('BDKaTfCrmeSihXEHjLFGvJyLGiodP7n3g7zFrHKTnE6x'),
        new PublicKey('6K4jM79yijUEFxdFhCFZSjav1nZji1gsxUWQE6XrC8YD'),
        new PublicKey('5aLP9N7W4sWjeUzUCBiH1mxGNcKxfMghDrG6Eaik9mWd'),
        new PublicKey('2Kdtutrfzfg6LpAUYQbnkAf9H2GdA9KyHDmwPt9UqcyF'),
        new PublicKey('3m4Qb7YYpf4rZJkba9TAVDL2MnzfraXKkQgCvhJEKRJs'),
        new PublicKey('2dczcMRpxWHZTcsiEjPT4YBcSseTaUmWFzw24HxYMFod'),
        new PublicKey('ANPPfLuytJ6c9rGeiARd6XhMRWvsLpAkUT3spocBv2fe'),
        new PublicKey('EG5DpbnuQQ988m3m1ZDpa6aPA6MnZzkikWZ6cWwjweia'),
        new PublicKey('4yD8SKwoA8B7k21dvsxRaTLr79CbFHq29PBFnwcCuc2s'),
        new PublicKey('9ojKRNtj8W5GvLFxpMrb7iLqGq1RkbzcHGBbGWmcpYii'),
        new PublicKey('B6CAW9Q8nzgDxT81YjaSdf3kQwrLghVbdiAJr7nN47px'),
        new PublicKey('4dtWi97ZfCaPyNMa89cCnGrYps4zu6qXBYNK4PTDEZjV'),
        new PublicKey('2KDqcdqBbeqg4u94BTkUfwRunB6ja3JPwcQDrYTdWGYV'),
        new PublicKey('Cr2K3qyqPMekk2QTwcw2a7x3gr8Mqpqa7vyTfyE6RYLJ'),
        new PublicKey('FAVSpnZsNWKTnPmn4qPttZjT6MiWyCQjUVzDuf6pLcTB'),
        new PublicKey('Ce8cvm76czMD9vjiqRP6ZkFUQfiTrustpS9XyuWtddeQ'),
        new PublicKey('H7ynJmJMo2GiA1jFK6kNaY7s5zrQtAZP8E57UokQXaEn'),
        new PublicKey('2YS1k4i2xrThW2eZ8cs6m1q7yDTRzRsWKs6KnBBLR31P'),
        new PublicKey('HWNE4fSF1RqB6CJ4iSC353AEn8bf9fm7XYydsbCt6qJm'),
        new PublicKey('BwX83UT4tgX8cHWzQSoEwBFueYZsDU69kV4YQNVSkJ2C'),
        new PublicKey('GymZwgYmamLpUTL3eBKA4XXbCAVmZkSxGcny1AYwxGgx'),
        new PublicKey('7khjhQbJcV1BiqZpYNUXiVn6CtvMDQJwPZ8VbZ1z6wxX'),
        new PublicKey('5ZQ3CwWS6JEJJocuWwPeH6qbH7T2N4yCjgSaVzznEWCA'),
        new PublicKey('AcsMjKfaafpuTo9vrx7PqFSxJi4E8rrPYEDqrCgZojve'),
        new PublicKey('Dz9j5w8yDNKoeKyExqUWJfe84JjL8dPiRNk6FrGmS2Lc'),
        new PublicKey('H656JiomQDU8Wxybmap22SmFnXSYGz8iV42fXz2HMGNE'),
        new PublicKey('6dCdRpwQB2GVXshcpVyDFVZA5FkfUNjmZCVKA4m1RiBh'),
        new PublicKey('CFqiPtUpiKh18o1KYtncLDsNpkTNVwvceGN8z1mGmvD1'),
        new PublicKey('GgJ3dBamB7vgWhq3Zmc7RXYbDKD6Ax4AQXx3MSeK95DV'),
        new PublicKey('9Fx9C2mmEre5hwXNBxzZb6Uscp773GSMaKTzjRMQQCkt'),
        new PublicKey('4AKAPqvQmmnJfkfohW59MsAYBYRu9eNJB4Xf4nJ2Yw2D'),
        new PublicKey('5Q6wwYjZPMWkHKrYohSMNxrqz3m6F42hEcRnSDy94rD4'),
        new PublicKey('3WL7EiRVG3Soct8Cfv9xnbgA2nhSULzyEUR668oZHctq'),
        new PublicKey('Hfx4dVpn632h3XX3GWc11y8b7ouZRjyQjjZ8thPCjcqg'),
        new PublicKey('ES4MhbocF5D98AeG2Fk7A564J99V876L5ZA77nSUnNVY'),
        new PublicKey('2M1Qf5C8zJAxkqKm2AK3H2xzYxWuMbhA2rzzPig9j247'),
        new PublicKey('9Qk5HxNpnXxbpaD8y9pfBvMWQYqABpHG8mrR1fjJtNAW'),
        new PublicKey('FMeUbyzofVutHpeqUco9peqAyDoPLZCjvBZuV2cduwxA'),
        new PublicKey('Mn6FeUkDHkrxNYh9iCtty85peHf4YtnKTqjaqQkE4R3'),
        new PublicKey('HfiqWFbXWQM9ZTnWQLBvv4Qsvg58iLiPsfGvEiXeNx4R'),
        new PublicKey('7pwXHZ4MSAT4CWJBB8uYi3teCxBXwgi8F6DLm39EwA3X'),
        new PublicKey('6VqFtL9WWsuG97mSY7vD8sgGBwAgjoiRXUxaZFnZsZ8E'),
        new PublicKey('Cgb4iehuTNAgaafXF9Y9e8N3wFpcrqbHC2vvCoBdBJXY'),
        new PublicKey('GXzow9dJwKk2QQLW779znijWrZBEFL5YC14CdMhASUU8'),
        new PublicKey('EDECTcgfdjdpwVPAgac4oAQwwW1oET4ZAqfRSjLaCT4v'),
        new PublicKey('8RsjvJ9VoLNJb5veXzbyc7DKqvPG296oY2BsPnuxPTQ2'),
        new PublicKey('CY8s6rQztkDeZsaDLaApvweCLjKNDvfdjyKvA4rGjqUc'),
        new PublicKey('7uGCZJSepSkWqujUw3Cz2sjXg4GW7rzJNXiKe13L7Am9'),
        new PublicKey('BxwyGBEdfmqZwvko3ZY8XaNhW7u6gFpBbDnu2XDxW9d9'),
        new PublicKey('GnzcyPiBJUiLWCWwVvnKATdKiwzUMJZPg4c3YoUAQvB5'),
        new PublicKey('5BUR22MZR9YivcYpsx9xp2aDJGKBcF9HWCYynBPw6r8'),
        new PublicKey('8GFK2j6x6fEi3o7db4ounurD8PDYafSpeJf8off3qK8p'),
        new PublicKey('J1Rm2S4v1ojsqtqVoh6NwuzQkv9v71hhoRyoBbdvH5fa'),
        new PublicKey('CEz5keL9hBCUbtVbmcwenthRMwmZLupxJ6YtYAgzp4ex'),
        new PublicKey('DKbpb5qxHhc2d4U7CmTBt4BF1eVvfkBsqxKLM4BCTcdR'),
        new PublicKey('8ewNqtPY3WtGmq6opBDBJMvGu5B3zshEFG67dJRsNATz'),
        new PublicKey('AepjvYK4QfGhV3UjSRkZviR2AJAkLGtqdyKJFCf9kpz9'),
        new PublicKey('5BAAVFfKb7xNF4Kscgtc7kqLtEjjZ2hM8NkE43J2nte8'),
        new PublicKey('GfpUVgQqk9SNcjP11XUVM8hvtAAD5mMwhY7fRWSZD8H2'),
        new PublicKey('9xXg8XD9NQvpK2XzK1ARSJSaFEpUNx2L63FrnYFVieQN'),
        new PublicKey('3xUYbqcgTm4t5cbs7va6441evoCoqZq3HofdgUFNfTMS'),
        new PublicKey('DTzvmLytpKEwJCKocWZeFYJiKCiCWB7vHTJo5PJDZGR5'),
        new PublicKey('EoXt4R1gyuPY8PZmXL95rgecszERmCqVfnxue6QpwpyX'),
        new PublicKey('CVt8bRum8gdXRLAnuxt66e2vtC9PdDexuhKKyDk87eno'),
        new PublicKey('BDFQqTfLVpSxrQYgZiesrEg8WxrTjcm3W8SA9MtABujh'),
        new PublicKey('55vEQ9LEwo6s98q4MRWPpgYwiBtkhDz2ppEAkNbjWT1L'),
        new PublicKey('2e5jv5eyVgFnyC2BzmL3r8GsqvJ5VMVecXffRsjaUxi6'),
        new PublicKey('H62RwxzuHiKkSTbrieJc9Xukj6ZZHfoMGZnSGnpEsWNo'),
        new PublicKey('uNn4DKMqXm8yJJRcZRY7MZVMnJxqy62mUgC2e1tHFQV'),
        new PublicKey('BzJU7gd1Pzo9XY8LfXESsZBsnmKt7Zc5xdbWbY3KJHSH'),
        new PublicKey('B9xEHj9AHhoaWZsCsKGNnaa7tojJRrd21ak7i4CevGhD'),
        new PublicKey('HEsY45jM3tkrxHxpYyaxhvDfJEDub27unKXYZ6zFnjpt'),
        new PublicKey('DgwAHUnarWGyE7fxEnqoJGBgp6wy5e41FmiwXXVxGcBv'),
        new PublicKey('CJhyKExm1sqFkcRnemEQj847TgqEsPEgE5GbiHFqntkH'),
        new PublicKey('CJQSJhT1NWaksQgD4yGN439MP46raZ4qDCo9aQ3vfWhH'),
        new PublicKey('ANXieKhnr6Bnz7S8CtCvFuVHdP6KKFJw7XSq9aP7LNbR'),
      ],
      programId: new PublicKey('6LtLpnUFNByNXLyCoK9wA2MykKAmQNZKBdY8s47dehDc'),
      globalConfig: new PublicKey('GKnHiWh3RRrE1zsNzWxRkomymHc374TvJPSTv2wPeYdB'),
      collateralInfos: new PublicKey('3v6ootgJJZbSWEDfZMA1scfh7wcsVVfeocExRxPqCyWH'),
    },
    scope: {
      oracleMappings: new PublicKey('Chpu5ZgfWX5ZzVpUx9Xvv4WPM75Xd7zPJNDPsFnCpLpk'),
      oraclePrices: new PublicKey('3NJYftD5sjVfxSnUdZ1wVML8f3aC6mp1CXCL6L7TnU8C'),
      programId: new PublicKey('HFn8GnPADiny6XqUoWE8uRPPxb29ikn4yTuPa9MF2fWJ'),
      configurationAccount: new PublicKey('AdTiP7QyjUyv6crF4H8z7fxJKU7Z5eCAGvJN1Y55cXxb'),
    },
    borrowing: {
      programId: new PublicKey('HubbLeXBb7qyLHt3x7gvYaRrxQmmgExb7fCJgDqFuB6T'),
      accounts: {
        stablecoinMint: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
        stablecoinMintAuthority: new PublicKey('AkzcmXAWWmGnVmyEfW5eeaHdUUrE9yxGaS2GmtV5UEMq'),
        hbbMintAuthority: new PublicKey('CNDdAftLoTNZUyb3Tb4WHFZaKDuGYUtZ23gUhYdzKZS'),
        mint: {
          ETH: new PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs'),
          BTC: new PublicKey('9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E'),
          SRM: new PublicKey('SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt'),
          RAY: new PublicKey('4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R'),
          FTT: new PublicKey('AGFEad2et2ZJif9jaGpdMixQqvW5i81aBdvKe7PHNfz3'),
          HBB: new PublicKey('HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6'),
          WSOL: new PublicKey('So11111111111111111111111111111111111111112'),
          MSOL: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          LDO: new PublicKey('HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p'),
          ORCA: new PublicKey('orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE'),
        },
        collateralVaultsAuthority: new PublicKey('HZYHFagpyCqXuQjrSCN2jWrMHTVHPf9VWP79UGyvo95L'),
        collateralVault: {
          SOL: new PublicKey('68yQyYj4YymoiQ644LVyRdvWLpw9xsjp67kmZhLMGnQp'),
          ETH: new PublicKey('HWTdcMDUF2UJqmD39dix2ATbKTJYQVhpPyoHgJTthpEz'),
          BTC: new PublicKey('4EhioLhAgbX18VGmX5Qf7qBGB7HEDQELcBxEGTk6c38G'),
          SRM: new PublicKey('5p8atdH8vX1mKgA38DPCC6tWGuGCiMRmZqFg1KrsECTW'),
          RAY: new PublicKey('BcmAzZsn6uZL8Hsv4ZWidXFshPS5oSyBXetf2ZD2i5i7'),
          FTT: new PublicKey('5EpCf866wXEgPFyTstgmJZJK1TPZJ3d1Jcvi2mT6EXFj'),
          MSOL: new PublicKey('9FWk5tni1jv6muvuUeh2JJdcfGcuzShkh2Ashzr6QWch'),
        },
        redemptionsQueue: new PublicKey('7PE2Ac3BM7pj7eoYRqBDzbKehwcfWQf8RCeFUy6AmVT5'),
        redemptionCandidatesQueue: new PublicKey('9MDc3EZR9cZvhB2sprPh2Tz6n1p9NNJMXiP7ZWPNSbpN'),
        liquidationsQueue: new PublicKey('3nBiYphUBFv8RGHNZYsTEFQthYnHBDoFJrSXfL59dNu7'),
        borrowingMarketState: new PublicKey('YSp9bJpQom2HA7VThxYZX9pNwrcBH88NBcBNWs5yskR'),
        borrowingMarketStates: [
          new PublicKey('YSp9bJpQom2HA7VThxYZX9pNwrcBH88NBcBNWs5yskR'),
          new PublicKey('B6gckY3KmWR2u1gwruE55Hxoj5uqiTTtuXLbE6Bu7bZq'),
          new PublicKey('2catbAPzCLX6YZA1axobPEYwbNo1XQaqhvWrZfR4Yxms'),
        ],
        borrowingVaultsV2: new PublicKey('EUEukBTF2X4gtFzkAJaqBcxUVbrSLn2yxLDBuKJj5JoZ'),
        stabilityPoolState: new PublicKey('245U3MMJ57YDGUSYRQxsJurqUhnXK4mjjvavbrvSn3uh'),
        epochToScaleToSum: new PublicKey('HDZR8Knvh9ETmCFGig3ocmzxijVgSrtPYSNCFoj2muRf'),
        stablecoinStabilityPoolVault: new PublicKey('GE6PqKhREVLRTGZs7rV5mJ2L3FAcj2fqohWCzTjhCTdQ'),
        stabilityVaults: new PublicKey('DytfDS9DqvCe86TGcFusmGpQgWa2889dcn34qZ1M5UYQ'),
        stablecoinStabilityPoolVaultAuthority: new PublicKey('CpNGqip6qTSmYEa3ANtPdHUzgD6HSWKeDE8ovNUtQLQy'),
        liquidationRewardsVaultSol: new PublicKey('gbbqSXucKBYcfvaPR2DevzExFpstvE6Ypu1Nfs3HGB1'),
        liquidationRewardsVaultSrm: new PublicKey('2hwuFn23CqZdsQ2hCbjRHLuNeHra1zfk6qAurTjEL133'),
        liquidationRewardsVaultEth: new PublicKey('CyfPwr1uV3pkhQtCdCpLvzzVvAngXYqq4KSAvkVxqhga'),
        liquidationRewardsVaultBtc: new PublicKey('EQxPELJWp87ziPFm6cnWEqqbGuzwbfbE4ejXgoBKfdJg'),
        liquidationRewardsVaultRay: new PublicKey('3aqwFikJ1sLwebd3GDdPxFPnzTaPVEQp9J7R3stNfPHL'),
        liquidationRewardsVaultFtt: new PublicKey('77PfF5Nqx8r3ZwLccxhyW9jmEYNLKrYTa4ruB8uAXQSA'),
        liquidationRewardsVaultMsol: new PublicKey('5xvgjTUyR5yBEW6oKYTeTd6BaQobGt7ECLPUearAxjBA'),
        liquidationRewardsVaultAuthority: new PublicKey('2LhXfDs64j5jVXNKa1qapMCMAZ9LXvKwHxpkp55wFh54'),
        borrowingVaults: new PublicKey('GNSn4pfNqxq1NeBoM3DSLrTp2oaQqptRy7MuaNpzA5fA'),
        globalConfig: new PublicKey('8HuhMF7ppoYdPD9fAdn9d9ZU1rL4ipty6CJEcZ5F17o1'),
        oracleMappings: new PublicKey('GKZhrh5reKiRkxkvQiFPT6ACtnVDB16DWbF1vfva5iod'),
        stakingPoolState: new PublicKey('5YPVVnBGYhribwt4UHCRWNKRs28DdgUgXQj8VrWikBP7'),
        borrowingFeesAccount: new PublicKey('8PJGWbSjY9C45yq9Jyr2GjMANQ3CuVajMGZwkgnNSBRF'),
        borrowingFeesVaultAuthority: new PublicKey('EDmzrjSjeS36dcYRzHuzrPxRnjZgfQoudfGGUA9mXyZr'),
        stakingVault: new PublicKey('9ixberQazk45T5XN3fZPakK2dWBdgJ6dyJeykxw3FN4K'),
        treasuryVault: new PublicKey('G1apbPBr9GdBWaXY4ejMu8b3NnmByvKT3BTvzEdKCgq6'),
        burningVault: new PublicKey('Ec7EqbEzbY5EW18E3scKoqYMYw6EGxySrRDpmCrs95e3'),
        burningVaultAuthority: new PublicKey('9wyZzZ77wg9JR25yiJi4333Fb2t3jiEVUGHoDZS6cdrE'),
        USDC: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'),
        pyth: {
          solProductInfo: new PublicKey('ALP8SdU9oARYVLgLR7LrqMNCYBnhtnQz1cj6bwgwQmgj'),
          solPriceInfo: new PublicKey('H6ARHf6YXhGYeQfUzQNGk6rDNnLBQKrenN712K4AQJEG'),
          ethProductInfo: new PublicKey('EMkxjGC1CQ7JLiutDbfYb7UKb3zm9SJcUmr1YicBsdpZ'),
          ethPriceInfo: new PublicKey('JBu1AL4obBcCMqKBBxhpWCNUt136ijcuMZLFvTP7iWdB'),
          btcProductInfo: new PublicKey('4aDoSXJ5o3AuvL7QFeR6h44jALQfTmUUCTVGDD6aoJTM'),
          btcPriceInfo: new PublicKey('GVXRSBjFk6e6J3NbVPXohDJetcTjaeeuykUpbQF8UoMU'),
          srmProductInfo: new PublicKey('6T1eJbKWyhZXEjmuBej9gPk3SRTagzrEQovCSwAWD57P'),
          srmPriceInfo: new PublicKey('3NBReDRTLKMQEKiLD5tGcx4kXbTf88b7f2xLS9UuGjym'),
          rayProductInfo: new PublicKey('EjtaES3pbMCaNrVFtZ5sT36WPXAnARZxCFsoEr2hsUKJ'),
          rayPriceInfo: new PublicKey('AnLf8tVYCM816gmBjiy8n53eXKKEDydT5piYjjQDPgTB'),
          fttProductInfo: new PublicKey('E7ymZgACaSd1fYLf2V7WkAmFkpRiWfAjm49R7bceny9K'),
          fttPriceInfo: new PublicKey('8JPJJkmDScpcNmBRKGZuPuG2GYAveQgP3t5gFuMymwvF'),
          msolProductInfo: new PublicKey('BS2iAqT67j8hA9Jji4B8UpL3Nfw9kwPfU5s4qeaf1e7r'),
          msolPriceInfo: new PublicKey('E4v1BBgoso9s64TQvmyownAVJbhbEPGyzA3qn4n46qj9'),
        },
        serumMarkets: {
          SOL: {
            marketAddress: new PublicKey('9wFFyRfZBsuAha4YcuxcXLKwMxJR43S7fPfQLusDBzvT'),
            requestQueue: new PublicKey('AZG3tFCFtiCqEwyardENBQNpHqxgzbMw8uKeZEw2nRG5'),
            eventQueue: new PublicKey('5KKsLVU6TcbVDK4BS6K1DGDxnh4Q9xjYJ8XaDCG5t8ht'),
            baseVault: new PublicKey('36c6YqAwyGKQG66XEp2dJc5JqjaBNv7sVghEtJv4c7u6'),
            quoteVault: new PublicKey('8CFo8bL8mZQK8abbFyypFMwEDd8tVJjHTTojMLgQTUSZ'),
            vaultOwner: new PublicKey('F8Vyqk3unwxkXukZFQeYyGmFfTG3CAX4v24iyrjEYBJV'),
            bidsAddress: new PublicKey('14ivtgssEBoBjuZJtSAPKYgpUK7DmnSwuPMqJoVTSgKJ'),
            asksAddress: new PublicKey('CEQdAFKdycHugujQg9k2wbmxjcpdYZyVLfV9WerTnafJ'),
          },
          ETH: {
            marketAddress: new PublicKey('8Gmi2HhZmwQPVdCwzS7CM66MGstMXPcTVHA7jF19cLZz'),
            requestQueue: new PublicKey('3ZSxZjD8o8JjPX1HVmQ59ED89R3uKNviRDCEmxCgv9dp'),
            eventQueue: new PublicKey('3z4QQPFdgNSxazqEAzmZD5C5tJWepczimVqWak2ZPY8v'),
            baseVault: new PublicKey('8cCoWNtgCL7pMapGZ6XQ6NSyD1KC9cosUEs4QgeVq49d'),
            quoteVault: new PublicKey('C7KrymKrLWhCsSjFaUquXU3SYRmgYLRmMjQ4dyQeFiGE'),
            vaultOwner: new PublicKey('FG3z1H2BBsf5ekEAxSc1K6DERuAuiXpSdUGkYecQrP5v'),
            bidsAddress: new PublicKey('3nXzH1gYKM1FKdSLHM7GCRG76mhKwyDjwinJxAg8jjx6'),
            asksAddress: new PublicKey('b3L5dvehk48X4mDoKzZUZKA4nXGpPAMFkYxHZmsZ98n'),
          },
          BTC: {
            marketAddress: new PublicKey('A8YFbxQYFVqKZaoYJLLUVcQiWP7G2MeEgW5wsAQgMvFw'),
            requestQueue: new PublicKey('H6UaUrNVELJgTqao1CNL4252kShLKSfwoboT8tF7HNtB'),
            eventQueue: new PublicKey('6NQqaa48SnBBJZt9HyVPngcZFW81JfDv9EjRX2M4WkbP'),
            baseVault: new PublicKey('GZ1YSupuUq9kB28kX9t1j9qCpN67AMMwn4Q72BzeSpfR'),
            quoteVault: new PublicKey('7sP9fug8rqZFLbXoEj8DETF81KasaRA1fr6jQb6ScKc5'),
            vaultOwner: new PublicKey('GBWgHXLf1fX4J1p5fAkQoEbnjpgjxUtr4mrVgtj9wW8a'),
            bidsAddress: new PublicKey('6wLt7CX1zZdFpa6uGJJpZfzWvG6W9rxXjquJDYiFwf9K'),
            asksAddress: new PublicKey('6EyVXMMA58Nf6MScqeLpw1jS12RCpry23u9VMfy8b65Y'),
          },
          SRM: {
            marketAddress: new PublicKey('ByRys5tuUWDgL73G8JBAEfkdFf8JWBzPBDHsBVQ5vbQA'),
            requestQueue: new PublicKey('Hr8Z93aWe4hhJbC5i7YTsPaSToziVh3vyMfv9GRqKFCh'),
            eventQueue: new PublicKey('6o44a9xdzKKDNY7Ff2Qb129mktWbsCT4vKJcg2uk41uy'),
            baseVault: new PublicKey('Ecfy8et9Mft9Dkavnuh4mzHMa2KWYUbBTA5oDZNoWu84'),
            quoteVault: new PublicKey('hUgoKy5wjeFbZrXDW4ecr42T4F5Z1Tos31g68s5EHbP'),
            vaultOwner: new PublicKey('GVV4ZT9pccwy9d17STafFDuiSqFbXuRTdvKQ1zJX6ttX'),
            bidsAddress: new PublicKey('AuL9JzRJ55MdqzubK4EutJgAumtkuFcRVuPUvTX39pN8'),
            asksAddress: new PublicKey('8Lx9U9wdE3afdqih1mCAXy3unJDfzSaXFqAvoLMjhwoD'),
          },
          RAY: {
            marketAddress: new PublicKey('2xiv8A5xrJ7RnGdxXB42uFEkYHJjszEhaJyKKt4WaLep'),
            requestQueue: new PublicKey('39mE6bYktM1XAKKmB6WN971X3Sa1yGkHxtCTWMkVrwN2'),
            eventQueue: new PublicKey('H9dZt8kvz1Fe5FyRisb77KcYTaN8LEbuVAfJSnAaEABz'),
            baseVault: new PublicKey('GGcdamvNDYFhAXr93DWyJ8QmwawUHLCyRqWL3KngtLRa'),
            quoteVault: new PublicKey('22jHt5WmosAykp3LPGSAKgY45p7VGh4DFWSwp21SWBVe'),
            vaultOwner: new PublicKey('FmhXe9uG6zun49p222xt3nG1rBAkWvzVz7dxERQ6ouGw'),
            bidsAddress: new PublicKey('Hf84mYadE1VqSvVWAvCWc9wqLXak4RwXiPb4A91EAUn5'),
            asksAddress: new PublicKey('DC1HsWWRCXVg3wk2NndS5LTbce3axwUwUZH1RgnV4oDN'),
          },
          FTT: {
            marketAddress: new PublicKey('2Pbh1CvRVku1TgewMfycemghf6sU9EyuFDcNXqvRmSxc'),
            requestQueue: new PublicKey('2ncWnY9QuCdNAX4gLutkNoKr9R1owDY1bhLLV1yH8Ukf'),
            eventQueue: new PublicKey('2XHxua6ZaPKpCGUNvSvTwc9teJBmexp8iMWCLu4mtzGb'),
            baseVault: new PublicKey('4LXjM6rptNvhBZTcWk4AL49oF4oA8AH7D4CV6z7tmpX3'),
            quoteVault: new PublicKey('2ycZAqQ3YNPfBZnKTbz2FqPiV7fmTQpzF95vjMUekP5z'),
            vaultOwner: new PublicKey('B5b9ddFHrjndUieLAKkyzB1xmq8sNqGGZPmbyYWPzCyu'),
            bidsAddress: new PublicKey('9HTDV2r7cQBUKL3fgcJZCUfmJsKA9qCP7nZAXyoyaQou'),
            asksAddress: new PublicKey('EpnUJCMCQNZi45nCBoNs6Bugy67Kj3bCSTLYPfz6jkYH'),
          },
          MSOL: {
            marketAddress: new PublicKey('6oGsL2puUgySccKzn9XA9afqF217LfxP5ocq4B3LWsjy'),
            requestQueue: new PublicKey('EHUoDPVVKR5Udp4EZPb4bsHZte5EEHc1PPTPXBgJEPEK'),
            eventQueue: new PublicKey('BC8Tdzz7rwvuYkJWKnPnyguva27PQP5DTxosHVQrEzg9'),
            baseVault: new PublicKey('2y3BtF5oRBpLwdoaGjLkfmT3FY3YbZCKPbA9zvvx8Pz7'),
            quoteVault: new PublicKey('6w5hF2hceQRZbaxjPJutiWSPAFWDkp3YbY2Aq3RpCSKe'),
            vaultOwner: new PublicKey('9dEVMESKXcMQNndoPc5ji9iTeDJ9GfToboy8prkZeT96'),
            bidsAddress: new PublicKey('8qyWhEcpuvEsdCmY1kvEnkTfgGeWHmi73Mta5jgWDTuT'),
            asksAddress: new PublicKey('PPnJy6No31U45SVSjWTr45R8Q73X6bNHfxdFqr2vMq3'),
          },
        },
        saber: {
          stablecoinSwap: new PublicKey('MARpDPs5A7XiyCWPNH8GsMWPLxmwNn9SBmKvPa9LzgA'),
        },
      },
    },
    kaminoLending: [
      {
        lendingMarket: new PublicKey('ABPeWVeRuvii6HuzTYcp1iH5a3ELfeVEviCtm3GfNnLV'),
        lendingMarketAuthority: new PublicKey('9gndVt4KDpv3Nd5Y1USq8tozArzwtUySJzzCwEdJZteB'),
        isPrimary: true,
        reserves: [
          {
            liquidityToken: {
              decimals: 9,
              symbol: 'SOL',
              mint: new PublicKey('So11111111111111111111111111111111111111112'),
            },
            address: new PublicKey('DDJzgWNupppRR7amWVeWzqop84QuyRA8xM7AQd1WGzCz'),
            collateralMint: new PublicKey('5NAXaYxGaBHpN89t3QFt9mg1kgBH8VH2VxFvSRXrp3Fx'),
            collateralSupply: new PublicKey('HpHv41G1wWhfqdFURq9KiCfeUurZPNHdVG3VyTdmCGXx'),
            liquiditySupply: new PublicKey('BfJe1fr88wsZcbcCRpHUXBsEv5ufo9YTvrNhewPcC5e4'),
            liquidityFeeReceiverAddress: new PublicKey('ErJBqDkonv8qYAKGLG5VXVSSz2hjPvYe2228W6YHxNRt'),
            pythOracle: new PublicKey('H6ARHf6YXhGYeQfUzQNGk6rDNnLBQKrenN712K4AQJEG'),
            switchboardOracle: new PublicKey('GvDMxPzN1sCj7L26YDK2HnMRXEQmQ2aemov8YBtPS7vR'),
          },
          {
            liquidityToken: {
              decimals: 6,
              symbol: 'USDH',
              mint: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'),
            },
            address: new PublicKey('5gCzanUXSCwHUvCPjRjQDSFaTxD8PgNzpgsaVi3L4nbB'),
            collateralMint: new PublicKey('BiXxYFkqmRvDWkSBJBh6fUMJwowPuQGgntQvNbWNR6LZ'),
            collateralSupply: new PublicKey('7YZdJrRdfGxn7xSBfbd8c6AMEHE99u2AoxZqBofwWk5Y'),
            liquiditySupply: new PublicKey('3uDAX3bjwoAPXocx4S1aqK32Npro2PYuUgqZPYFH897W'),
            liquidityFeeReceiverAddress: new PublicKey('GRYZLAxLwcdj8xgqrSSNUdeyfmsrHctARLSCMzkthe2L'),
            pythOracle: new PublicKey('nu11111111111111111111111111111111111111111'),
            switchboardOracle: new PublicKey('yeHZhfVXTwBZzYcvmnSraVuKg6AP6YvTzfD49eLr92D'),
          },
        ],
      },
    ],
  },
  {
    cluster: 'devnet',
    kamino: {
      programId: new PublicKey('E6qbhrt4pFmCotNUSSEh6E5cRQCEJpMcd79Z56EG9KY'),
      globalConfig: new PublicKey('7of1j58my7FrQrPce81xUcfHARchvVFuSKEoyuB8WWZj'),
      collateralInfos: new PublicKey('EZTVhq1x8PzBVj7kRSJqL2aVG115mfyAf8wDZdMESyeR'),
      mints: [
        { address: new PublicKey('AcU8CfJiLEBn1x7Cgx8atX6DdebmdQtNSsJBkQyf6Q4L'), scopeToken: 'USDT' },
        { address: new PublicKey('kfZGSThBdZbZY6cDSHP7NmCWa6D2hFc5kjBuGHREzZ3'), scopeToken: 'USDH' },
        { address: new PublicKey('HEzfH7PCNSCU92zdk3iaKG4E9hQTErfgVGvqgywEvPzu'), scopeToken: 'USDC' },
        { address: new PublicKey('ESba8sT1R7WPiE3weBU1u6UqEmXRuM8Rs1LLvXayEizf'), scopeToken: 'STSOL' },
        { address: new PublicKey('2wMQTELEgEcK7V3gwZBH58WvGcRZsyaWNpebqyFugGKe'), scopeToken: 'MSOL' },
        { address: new PublicKey('So11111111111111111111111111111111111111112'), scopeToken: 'SOL' },
      ],
      whirlpoolsToSnapshot: [],
      raydiumPoolsToSnapshot: [],
      strategies: [
        new PublicKey('AvRMXt1MM9bdyE4yrnbVYjzYWWx8sdhkXPFbmxeb3rq6'),
        new PublicKey('yT2bBMrE4AVG3BM8LHjDSr1yketzabmfp3rYimS36C9'),
        new PublicKey('2H4xebnp2M9JYgPPfUw58uUQahWF8f1YTNxwwtmdqVYV'),
        new PublicKey('EbRR6C3uCRwnHjvbJuuiaipvVCVLYb2ZL5B3GH4zm3FH'),
      ],
    },
    scope: {
      oracleMappings: new PublicKey('4PoKkcsQakSMovMWh127gviWPpA6wGyY8uZWavccXAGE'),
      oraclePrices: new PublicKey('Aprk2sZNvxZNUpgq2WuS3VNkbxh35aCqJd1GbtBZzkG5'),
      programId: new PublicKey('3Vw8Ngkh1MVJTPHthmUbmU2XKtFEkjYvJzMqrv2rh9yX'),
      configurationAccount: new PublicKey('qAN1wkxEzBg7AzeLC4sGT61czYvDiotZTMKojVL2o2E'),
    },
    borrowing: {
      programId: new PublicKey('m9P5MBXVg33N5cWuHPd4YctGhKy3p6iDdHr7Ro2YRgr'),
      accounts: {
        stablecoinMint: new PublicKey('HWzkNyXynnC3mAZAL4yKZNvWs3SwS9eBVKdzmKcxYHSH'),
        stablecoinMintAuthority: new PublicKey('Bv3oYDiEfetCx5J2tBDDTefjRc1RirtjukEfHaRBoX71'),
        hbbMintAuthority: new PublicKey('FeVZfsKhu4LJQNSDvq1RHwp5dNhFD3PFW1kBAk3PAYhw'),
        mint: {
          WSOL: new PublicKey('So11111111111111111111111111111111111111112'),
          ETH: new PublicKey('2DVyKwW17MxDXaLhWpWXtbVa64JBwaHmLJ1txXNJgRGi'),
          BTC: new PublicKey('6cA8Y9Jm2jW2rvUcpBHC9kUjctw9dMF3gPfWZd5bcr57'),
          SRM: new PublicKey('314VQ6r5m3sxdfB8cWJBS8MrAb5nVY5PvpcR7jN1PnY2'),
          RAY: new PublicKey('FDYnqkgmF9t8o4QxA7YYL2wSLfun2kXXgA6auQBzzXLU'),
          FTT: new PublicKey('7DmsbJXUcVwNmj84Cqd91KrEzJyLKGPHdKTqKTwHwsHE'),
          HBB: new PublicKey('GnzBpWxvN75JXxKndPwJ63ABdKDACMDWTC5iTUqGzSsD'),
          MSOL: new PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
          LDO: new PublicKey('99nKXBggZF5Xxbc9RPD1kzD1ZP1TPXQyNSCTn1MK2Dbi'),
          ORCA: new PublicKey('orcarKHSqC5CDDsGbho8GKvwExejWHxTqGzXgcewB9L'),
        },
        collateralVaultsAuthority: new PublicKey('5t8jZ1T6cR79vEu5Vo1Jc6Q3RaYtLsNJdPTLLu4z9vX3'),
        collateralVault: {
          SOL: new PublicKey('ZRJEmigJ8Hjs2NyTmyHkvas2HZmMKrrNAwNnJ4dFgZQ'),
          ETH: new PublicKey('DAaiG32meXcHwpxJgcAqTfaMMNhW3yKLNeJdNyaiRt2G'),
          BTC: new PublicKey('9A9ZpnXcnDZLHkHt8Fcro3XLgqGNoVJhx7ndo74MKn4B'),
          SRM: new PublicKey('84tA2z64nuBDpKN9Vm75HGDbqix51RyftDWrNrY3TfrF'),
          RAY: new PublicKey('DY3UAwAtiJXwdHjrToKzDHci5fLc2Spo3cSav5Ncsymz'),
          FTT: new PublicKey('6Dw7ofQLGHcdaMPtYBY5d37ABEtxdqk3omy2eWLzyV17'),
          MSOL: new PublicKey('9rN5H8SxGMfaabwHLg4x7xCSKpvPH218VGT4tGHmjMdH'),
        },
        liquidationsQueue: new PublicKey('66QZM6UAKFpUeKWRe5spag5JEfT4ycJ1UtSzeffTiQJK'),
        borrowingMarketState: new PublicKey('FqkHHpETrpfgcA5SeH7PKKFDLGWM4tM7ZV31HfutTXNV'),
        borrowingMarketStates: [
          new PublicKey('FqkHHpETrpfgcA5SeH7PKKFDLGWM4tM7ZV31HfutTXNV'),
          new PublicKey('2pjsM2weitsEP3w1Q4N7bLvFYmdNBWCw1H3E9k6rVQTy'),
          new PublicKey('5rDSgRsoq2sJQyzwLsmucvqMrNmYQDMr6L3xoXkxtadY'),
        ],
        stabilityPoolState: new PublicKey('FB1e3ACdWSgKVDaVp7YRWB64JgFrUNPrxm6ukKDjjKg'),
        epochToScaleToSum: new PublicKey('FPUTB5KsZQhPrJS6QmUzgAErYcfHBcyVwRSQcvCLzeVi'),
        borrowingVaultsV2: new PublicKey('BHgw9kZcK6LVSadiqUZYBxe8rCzTcDq1dxsJcspLmWPX'),
        stablecoinStabilityPoolVault: new PublicKey('EdSUZ9WtLj7QFrJ5wNPFZGhrf8JP1nofskpHJ8Jotgt3'),
        stabilityVaults: new PublicKey('CSjeLjho28HxsWhYqzh4XqbDAoYTo63d2zn34BBRFkm6'),
        stablecoinStabilityPoolVaultAuthority: new PublicKey('46ephmWbPP6pZQU8NR123NX1unJ6eYJSK3pf8pmYA8o6'),
        liquidationRewardsVaultSol: new PublicKey('GdfNFLiFAxFfUbns6JaWheChqbHByBgW9EmqykEMisdm'),
        liquidationRewardsVaultSrm: new PublicKey('9wFvXWJdrSyzGaKkZYhiWPmG3qKeAtemcQs5sgR7KdTV'),
        liquidationRewardsVaultEth: new PublicKey('H6U9myYfmYHvz1BQBDcARinaFFVSbeHV4r9VJPiUJBxV'),
        liquidationRewardsVaultBtc: new PublicKey('9Xm3RaKVgon2ViU3QwvgPE5Gcd5mTRwdzVoRQt56Pkbt'),
        liquidationRewardsVaultRay: new PublicKey('2HSSye9cZnE3VS84M6z9LnobcdeYukUpZm23n3KiBve2'),
        liquidationRewardsVaultFtt: new PublicKey('BTNN8XfsH3GyyUpBZUy1gKPrYhW4ng1aaiKQy4kkQtS9'),
        liquidationRewardsVaultMsol: new PublicKey('DjpZNFotV5XgWgt4W7hh7TJpqgES4w4Nyh2x96sAJHYa'),
        liquidationRewardsVaultAuthority: new PublicKey('83NPhEayosoeucxJGi8EPpar1oDBzu16wa8ttTUc7bJK'),
        borrowingVaults: new PublicKey('2rVBBq4gbWgNCpaDAw6XScwaKxnXEEeXSXFCz5Dz8dSm'),
        globalConfig: new PublicKey('4tKUbxbw9rh4FkxdSG5XgmHjGa2ygJeBdRGGnVuBYCj3'),
        oracleMappings: new PublicKey('5MkiLwSR4qhhLrnfio9tmre9oepjUkf6FXwsD8Fne1nT'),
        stakingPoolState: new PublicKey('ESmugrx5Toe58tr5mXWeEFVG36ifmV39QXTohekw5Bc5'),
        borrowingFeesAccount: new PublicKey('CsNHgkVrHzgjbg53YdZpXqg7SzFzMDDomXGTAJJ8Xyo1'),
        borrowingFeesVaultAuthority: new PublicKey('6TsuFvmMQHNCbBfkp9UBSJmSb16XvFBAp9WwSkTGHXZX'),
        stakingVault: new PublicKey('4GT3ESGXLhYZGidYm2UCzyhvhhAjrFxs8pSgCakFd72h'),
        treasuryVault: new PublicKey('BJBW7y4kFNidyzJQM6SAwceobzSVyBjrPi2FGCPR9wvv'),
        burningVault: new PublicKey('F9ZFxRgTZQPgRRnxG8CsQ8PjoqhrQkFSCojDbCyzjFeA'),
        burningVaultAuthority: new PublicKey('FtUEyCRySPDMgZZYQTdVnz7gxM7f4LeZyKPVaSNME4gb'),
        USDC: new PublicKey('KYz9NWoYmvYhKHCHgJ1cT6G5WV8pZwimgbH3Seu8pJw'),
        pyth: {
          solProductInfo: new PublicKey('3Mnn2fX6rQyUsyELYms1sBJyChWofzSNRoqYzvgMVz5E'),
          solPriceInfo: new PublicKey('J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix'),
          ethProductInfo: new PublicKey('2ciUuGZiee5macAMeQ7bHGTJtwcYTgnt6jdmQnnKZrfu'),
          ethPriceInfo: new PublicKey('EdVCmQ9FSPcVe5YySXDPCRmc8aDQLKJ9xvYBMZPie1Vw'),
          btcProductInfo: new PublicKey('3m1y5h2uv7EQL3KaJZehvAJa4yDNvgc5yAdL9KPMKwvk'),
          btcPriceInfo: new PublicKey('HovQMDrbAgAYPCmHVSrezcSmkMtXSSUsLDFANExrZh2J'),
          srmProductInfo: new PublicKey('6MEwdxe4g1NeAF9u6KDG14anJpFsVEa2cvr5H6iriFZ8'),
          srmPriceInfo: new PublicKey('992moaMQKs32GKZ9dxi8keyM2bUmbrwBZpK4p2K6X5Vs'),
          rayProductInfo: new PublicKey('3BtxtRxitVDcsd7pPUWUnFm9KvmNDy9usS4gE6pUFhpH'),
          rayPriceInfo: new PublicKey('EhgAdTrgxi4ZoVZLQx1n93vULucPpiFi2BQtz9RJr1y6'),
          fttProductInfo: new PublicKey('63VWd2FVbukVozZ1okHt8wVMq7enAYFXYnmp2DUQtBBJ'),
          fttPriceInfo: new PublicKey('6vivTRs5ZPeeXbjo7dfburfaYDWoXjBtdtuYgQRuGfu'),
          msolProductInfo: new PublicKey('os3is9HtWPHW4EXpGAkdr2prdWVs2pS8qKtf2ZYJdBw'),
          msolPriceInfo: new PublicKey('9a6RNx3tCu1TSs6TBSfV2XRXEPEZXQ6WB7jRojZRvyeZ'),
        },
        serumMarkets: {
          SOL: {
            marketAddress: new PublicKey('BbNNvJ9Ayh23qdaG7vvn8y4FGkBiDipCcFa4L6sy6qkH'),
            requestQueue: new PublicKey('8jWfsdCT1tsJSBxEtVnD695Bvt6j1vTuXkFjFKXWpzxm'),
            eventQueue: new PublicKey('82SBwWDx9gcttA68fq56Cid3SPujFX3ZMaTRBW8Nncf4'),
            baseVault: new PublicKey('6aJXaJqEEA8WCoXgJgMevR7Mtg4k2kq7Bv7ZFw7UmgG7'),
            quoteVault: new PublicKey('89spP5pkVQyEBBjuDQLPyHQc5JCbjHxLmqDht2PgMwj8'),
            vaultOwner: new PublicKey('AJL9Zf7Jx6XTfQTzUhL8FATLfbHRHJ799U4ysKt2BL4k'),
            bidsAddress: new PublicKey('8RhfhGjmAHYpWa44Y3JY5aCacFpyhCJWGMC7SLzRFQbr'),
            asksAddress: new PublicKey('2wMQj33zSng8pcznYZMfGJPwNFFLH7k6DgRBcBHdVdKp'),
          },
          ETH: {
            marketAddress: new PublicKey('AohVcYC9UBWe6zuf9dV3okbK4YTWwTPgQtVSYgtGNk2f'),
            requestQueue: new PublicKey('3x11hXJx6FxMYfvzmmFUFiPx25wVkiEaSAsQ6yjrxEx7'),
            eventQueue: new PublicKey('2nA72kf54iPJsL9Ar5SC5Q6FXUQfz7RfXyUVHQp183TM'),
            baseVault: new PublicKey('4ZhvPAcEUBbbYM4WVe6oMCEyYE1GEBmMhVMPeKibdSrL'),
            quoteVault: new PublicKey('An8Lkd9JjDn1dJHWbijwJEWuf5wFTLkZ6ABqxU3uTS85'),
            vaultOwner: new PublicKey('2WBeH92fiSzUxTRpoD9ECLdpFPZZVmyW3SP9uWUtrT9U'),
            bidsAddress: new PublicKey('EvxjBDnJrGH6x5urDBHcCP4awEy8xgqBnXFyEgyQfgSa'),
            asksAddress: new PublicKey('7iXouzTk7mxDToqPeog5ZiimU7ZTZE2ebC2ojFmfiGuU'),
          },
          BTC: {
            marketAddress: new PublicKey('H3Kc3iFCjXHxK7igtYL8AYEJWUEcu6CwWrmJLuEaV5ur'),
            requestQueue: new PublicKey('EK5LtxC3AuNAHGqBvpCY4hE76v8TxvvV4qJB2tm9zeDK'),
            eventQueue: new PublicKey('59aR7wfrHgRMSqYMR1mds7MudJggka688e5ibH14Vo5g'),
            baseVault: new PublicKey('MAuEtSCnfXfEovBHTCPBDx1FUak2d8NripHAN2MnieY'),
            quoteVault: new PublicKey('2wSSHX1hhcUBPkkQ3kXL6k3N6zd8Us7eNa4E4KSho6qB'),
            vaultOwner: new PublicKey('2HP6SYHycgByXSNdTj3Pf1dwHdG9u1mydF8fHtbjx5Mm'),
            bidsAddress: new PublicKey('GCnJtgrJq4pouKquUyFGzucPQx5tLC43JW9LQgTR7Fr'),
            asksAddress: new PublicKey('7iKSZm61ZFWKSPTCKskZU6QWKbBRH7UrgB4uwWBzSXE8'),
          },
          SRM: {
            marketAddress: new PublicKey('8g2t7hBTFuv2q1HkhvKsf5hPGSq3uv7ztvRCFvVaG7E2'),
            requestQueue: new PublicKey('AvmtFUwV84MRYLkuZWpBQZ4MFLfentkvAJ49nGGejnQ1'),
            eventQueue: new PublicKey('FYoHfoGS7HDGsCGfrb9CeZCsMUeHHuBhN9qjUMzPaQQQ'),
            baseVault: new PublicKey('DE7gakW5Gb43n9TQSnXLmUakVGowFU1ZhJTBEXr7Cvq5'),
            quoteVault: new PublicKey('HNMxbFLg2wrgoUxHu3bTvz1XPj9n4buioou3WaQqzwrH'),
            vaultOwner: new PublicKey('HCUkFFzirnknTGb4tHTvMpQCk1TPGaZfkdXYf8JrjUL6'),
            bidsAddress: new PublicKey('A5Tq9rLx9kEdqEAXtKiSLDCfwNAfLL8d3U4S3u3sMJZc'),
            asksAddress: new PublicKey('95Z8NkfChbDsdUM5LyLwJ5dHyS94Qjth7e9cepEzuTZs'),
          },
          RAY: {
            marketAddress: new PublicKey('8XtEufHU7TbNNChTvBhShZGZc1adHNkTmEqv4W9Q3RYK'),
            requestQueue: new PublicKey('7GEMsQ49aUqwDnum624uvjXrZyiCnEW72zw9WsFquXMq'),
            eventQueue: new PublicKey('2nvokrESHbhrfi6QHrxoASs8ziEmcs5kPKotrvJ7xRJ2'),
            baseVault: new PublicKey('HZqiavQ6wE4siwFgvDfoxsgtgLrVNbndmULdTk3FQYHe'),
            quoteVault: new PublicKey('5KRyGWDuq8KJUQxTSEf7Ku8eFLkwCFtWBXF6WJJ6jGy9'),
            vaultOwner: new PublicKey('Hk5VVfKTL1Z4o54XwykvE4Rp9qgdZY7rUCrWfGMhLLzq'),
            bidsAddress: new PublicKey('GKagffnBN64rNgu7yFko5uzPRqWCrM5UXfsbC7ZQbFxt'),
            asksAddress: new PublicKey('54K3medHRc2Q4P1oMnKS9PoANpbyswbLC9U2jCEiEhUi'),
          },
          FTT: {
            marketAddress: new PublicKey('J8Y4NY8Rzk8Y2hR7JtergtL1xLXdeguD9G8aD9gmkpyu'),
            requestQueue: new PublicKey('94uGcffyTn5SFMqBKJ7ntxeLABLqy2ADf4VpfQcMtt5U'),
            eventQueue: new PublicKey('8mMsobfCGFnqnoo3hjTCA449LRCqFv7nM5CobZGnSDij'),
            baseVault: new PublicKey('EuoNht3Uc4hcBcu5Reep54HSXgvpXrgsVsNeEeenA5kf'),
            quoteVault: new PublicKey('FTwLw8s6kUjKwfworryNSsefCZUkAUnkRuBmDjZxgGwn'),
            vaultOwner: new PublicKey('GYUYJBrsCzJUMUbTTkiCs54d2m7Vh4eDMqyKtpbs52d1'),
            bidsAddress: new PublicKey('5ZboPX8DupNM8LFTXHZBGd3JV24xcJAfHfrjFntDvLL3'),
            asksAddress: new PublicKey('7whNVtz7Seqm46D8W4poYTsjPYsxp2jsPThVHvQ1UtgH'),
          },
          MSOL: {
            marketAddress: new PublicKey('HH6wc5BUZtDE3dpp6nzpHQzyryQyk9nzeCmGz9eAkpBH'),
            requestQueue: new PublicKey('6GF9C52akeqEvvycvRjamMKHwYHc1qnzLonKVRjb8rAx'),
            eventQueue: new PublicKey('5HqNWFTGqojWHKAPiDTSyBmcDK8qQeEixXtB22WNo1y'),
            baseVault: new PublicKey('GFvzeLV8aqLJPWjSVrx3mRnZjCiiWykmNPUA4Ef2NvVy'),
            quoteVault: new PublicKey('FYbLCiUgaTiBRKnLSAPHSaDDc5QXKPHxxmpZhwaeqqon'),
            vaultOwner: new PublicKey('FV5e18t2uZv8w2qbu73qQjAGcwoTRpkn7Nf6JySJJ5oZ'),
            bidsAddress: new PublicKey('GmBGVj1aEaMeCHq9LqDJpcDQn7nGcpXvB3LCjqsWxGt7'),
            asksAddress: new PublicKey('DB89DPTikq6KEsZLsiu7snzjzM9f2ohaAt5t9kJH1THF'),
          },
        },
        saber: {
          stablecoinSwap: new PublicKey('MARpDPs5A7XiyCWPNH8GsMWPLxmwNn9SBmKvPa9LzgA'),
        },
        redemptionsQueue: undefined,
        redemptionCandidatesQueue: undefined,
      },
    },
    kaminoLending: [
      {
        lendingMarket: new PublicKey('C3JSmPMmwHwJJuz9S4PBcsd1VVVLLvFFK2J36jqGRVDo'),
        lendingMarketAuthority: new PublicKey('4fMAG8JYALfQE2tmwPcf59CbKVTvBSeveU3s8jTUqrg6'),
        isPrimary: true,
        reserves: [
          {
            liquidityToken: {
              decimals: 9,
              symbol: 'SOL',
              mint: new PublicKey('So11111111111111111111111111111111111111112'),
            },
            address: new PublicKey('6oHq4yaRWTtQ9QakJWvrryovdFMd2PY8jktmgSXj43x5'),
            collateralMint: new PublicKey('EhTKUYNtcSbPkt2MCmiYXryzxVgjfAroJFzL3XTrE58q'),
            collateralSupply: new PublicKey('26zUYzMq1eAB4mCiyrajnqc4AK2Dp1WfmNYLqyJpccXn'),
            liquiditySupply: new PublicKey('6Apg9g69rXZAmZKY65BiS8k7hJyhRYrHmiqe4q9BEkEs'),
            liquidityFeeReceiverAddress: new PublicKey('9PtwCrYHEfRaCaPeZprim4HcgsjrMnDb8KJVwmNHLP2B'),
            pythOracle: new PublicKey('J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix'),
            switchboardOracle: new PublicKey('GvDMxPzN1sCj7L26YDK2HnMRXEQmQ2aemov8YBtPS7vR'),
          },
          {
            liquidityToken: {
              decimals: 6,
              symbol: 'USDH',
              mint: new PublicKey('kfZGSThBdZbZY6cDSHP7NmCWa6D2hFc5kjBuGHREzZ3'),
            },
            address: new PublicKey('7UvdRA9pkxL1f16APLEqvBTK7pa27BbLQuSE4u2GZcQ8'),
            collateralMint: new PublicKey('J73zc1xaahfaZZ9kFUfBUMjSBCnFprJCF8N9NY64wdEE'),
            collateralSupply: new PublicKey('4hPPiqZRZ8LnyV38jtEdCH7NACSQYHoa4gBThnDzneTk'),
            liquiditySupply: new PublicKey('77vPcgAEUyTTGJDgG6dbzzsXvGCrzUmdxnqzyKrvwm8g'),
            liquidityFeeReceiverAddress: new PublicKey('7ck3jYXgytArTYc8XzxHB5EWJzMfkqEWupvmVrpzcKyk'),
            pythOracle: new PublicKey('nu11111111111111111111111111111111111111111'),
            switchboardOracle: new PublicKey('6Hn9n8eKbbzxMCpkkZBYjS9kHktfMDucQ77jhHmjasuq'),
          },
          {
            liquidityToken: {
              decimals: 6,
              symbol: 'USDC',
              mint: new PublicKey('HEzfH7PCNSCU92zdk3iaKG4E9hQTErfgVGvqgywEvPzu'),
            },
            address: new PublicKey('D81J5UpjPFd5k71KLFzVWVX1YVcS81tZnKrXJkDw5SGm'),
            collateralMint: new PublicKey('5BoshzFzGjiL1DRkDAV8JaHfbsgvpjJCSHCbgBr2t8sn'),
            collateralSupply: new PublicKey('6TF5DVm4ZDL1THaBug1T95f5yENu4myFgwFZq5iYtAVB'),
            liquiditySupply: new PublicKey('4ZyyAKpLBjbdjUDkjWL6dTJNgBP7CAb2JMi2bLC9ghUN'),
            liquidityFeeReceiverAddress: new PublicKey('EvdusCsBnx6snTLeXhc5isAhQ6HuTdBhyGLHnRhGxHiJ'),
            pythOracle: new PublicKey('38xoQ4oeJCBrcVvca2cGk7iV1dAfrmTR1kmhSCJQ8Jto'),
            switchboardOracle: new PublicKey('BjUgj6YCnFBZ49wF54ddBVA9qu8TeqkFtkbqmZcee8uW'),
          },
          {
            liquidityToken: {
              decimals: 9,
              symbol: 'MSOL',
              mint: new PublicKey('2wMQTELEgEcK7V3gwZBH58WvGcRZsyaWNpebqyFugGKe'),
            },
            address: new PublicKey('ETi6oEW9ZXtZTjdSL47kWdD3WmfsqfT3DSMDkMhQ5mMh'),
            collateralMint: new PublicKey('2jvcBAbrAQaWb6jq6GJ2yTnpK5rcxCx81SessLqninWd'),
            collateralSupply: new PublicKey('3sPoXAXmzi7maN6p7e6m3RYBdw7axciUmhYBdr9bVtZr'),
            liquiditySupply: new PublicKey('FK4Ni5pUMwXDrcBAQgpk7GDLeTEA3NKtX5wjBv1sGXC4'),
            liquidityFeeReceiverAddress: new PublicKey('5iaGemkKZ4wgTQb6KBfewE6qBd2va9CxiNkgMtpJKEZh'),
            pythOracle: new PublicKey('9a6RNx3tCu1TSs6TBSfV2XRXEPEZXQ6WB7jRojZRvyeZ'),
            switchboardOracle: new PublicKey('nu11111111111111111111111111111111111111111'),
          },
          {
            liquidityToken: {
              decimals: 9,
              symbol: 'STSOL',
              mint: new PublicKey('ESba8sT1R7WPiE3weBU1u6UqEmXRuM8Rs1LLvXayEizf'),
            },
            address: new PublicKey('3pbzXZVF8SYChzvaERWCFdk4VMqabAQMFd7Qayw5UtKE'),
            collateralMint: new PublicKey('71NSRvWeUbZqzqyJM2HEDEPsD6E4kurFbF4pKtWDdmP'),
            collateralSupply: new PublicKey('DM8ZLxgeMnyT8H9bZVmG1KHHVAvaZKXzHcCGiYY8bMxz'),
            liquiditySupply: new PublicKey('DUXxfwZQhCVcUswQLLjqygVXziZAZoK2kvGKTEvHFwEo'),
            liquidityFeeReceiverAddress: new PublicKey('4tADr67qkn8SVWM1zaTdSs3bva2gvhowqdXbY8gugUBY'),
            pythOracle: new PublicKey('2LwhbcswZekofMNRtDRMukZJNSRUiKYMFbqtBwqjDfke'),
            switchboardOracle: new PublicKey('nu11111111111111111111111111111111111111111'),
          },
          {
            liquidityToken: {
              decimals: 8,
              symbol: 'ETH',
              mint: new PublicKey('2DVyKwW17MxDXaLhWpWXtbVa64JBwaHmLJ1txXNJgRGi'),
            },
            address: new PublicKey('GKqcS3WZ2uzfG3F8qC4RfSgToqdrzRyAgQXJPCNf6S7r'),
            collateralMint: new PublicKey('71NSRvWeUbZqzqyJM2HEDEPsD6E4kurFbF4pKtWDdmP'),
            collateralSupply: new PublicKey('DM8ZLxgeMnyT8H9bZVmG1KHHVAvaZKXzHcCGiYY8bMxz'),
            liquiditySupply: new PublicKey('DUXxfwZQhCVcUswQLLjqygVXziZAZoK2kvGKTEvHFwEo'),
            liquidityFeeReceiverAddress: new PublicKey('4tADr67qkn8SVWM1zaTdSs3bva2gvhowqdXbY8gugUBY'),
            pythOracle: new PublicKey('EdVCmQ9FSPcVe5YySXDPCRmc8aDQLKJ9xvYBMZPie1Vw'),
            switchboardOracle: new PublicKey('HNStfhaLnqwF2ZtJUizaA9uHDAVB976r2AgTUx9LrdEo'),
          },
          {
            liquidityToken: {
              decimals: 6,
              symbol: 'USDT',
              mint: new PublicKey('AcU8CfJiLEBn1x7Cgx8atX6DdebmdQtNSsJBkQyf6Q4L'),
            },
            address: new PublicKey('FHTZSFkp61hzaZZ5LR3rZPA7wVgcdyd39X889PFNagsy'),
            collateralMint: new PublicKey('4zsscY7tKobgCkqYt9etBCj5EfetfsT4Fw1htKnTaQTf'),
            collateralSupply: new PublicKey('DVs8NKS2kT9irngA69FwAnuCM8zjtgDQYi65X5F1PtCv'),
            liquiditySupply: new PublicKey('A2rU482UhbxzX8wuFs5M2EubKXDQEPZZC4tPZ5aeMG6k'),
            liquidityFeeReceiverAddress: new PublicKey('CrrAU1NYpogx2Lh9smfwx1gVXHApFtm64Bf6MuRdPmMu'),
            pythOracle: new PublicKey('38xoQ4oeJCBrcVvca2cGk7iV1dAfrmTR1kmhSCJQ8Jto'),
            switchboardOracle: new PublicKey('ETAaeeuQBwsh9mC2gCov9WdhJENZuffRMXY2HgjCcSL9'),
          },
        ],
      },
    ],
  },
  {
    cluster: 'localnet',
    kamino: {
      programId: new PublicKey('E6qbhrt4pFmCotNUSSEh6E5cRQCEJpMcd79Z56EG9KY'),
      globalConfig: new PublicKey('GKnHiWh3RRrE1zsNzWxRkomymHc374TvJPSTv2wPeYdB'),
      collateralInfos: new PublicKey('3v6ootgJJZbSWEDfZMA1scfh7wcsVVfeocExRxPqCyWH'),
      mints: [
        { address: new PublicKey('AcU8CfJiLEBn1x7Cgx8atX6DdebmdQtNSsJBkQyf6Q4L'), scopeToken: 'USDT' },
        { address: new PublicKey('USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX'), scopeToken: 'USDH' },
        { address: new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'), scopeToken: 'USDC' },
        { address: new PublicKey('ESba8sT1R7WPiE3weBU1u6UqEmXRuM8Rs1LLvXayEizf'), scopeToken: 'STSOL' },
        { address: new PublicKey('2wMQTELEgEcK7V3gwZBH58WvGcRZsyaWNpebqyFugGKe'), scopeToken: 'MSOL' },
        { address: new PublicKey('So11111111111111111111111111111111111111112'), scopeToken: 'SOL' },
      ],
      whirlpoolsToSnapshot: [],
      raydiumPoolsToSnapshot: [],
      strategies: [
        new PublicKey('AvRMXt1MM9bdyE4yrnbVYjzYWWx8sdhkXPFbmxeb3rq6'),
        new PublicKey('yT2bBMrE4AVG3BM8LHjDSr1yketzabmfp3rYimS36C9'),
        new PublicKey('2H4xebnp2M9JYgPPfUw58uUQahWF8f1YTNxwwtmdqVYV'),
        new PublicKey('EbRR6C3uCRwnHjvbJuuiaipvVCVLYb2ZL5B3GH4zm3FH'),
      ],
    },
    scope: {
      oracleMappings: new PublicKey('Chpu5ZgfWX5ZzVpUx9Xvv4WPM75Xd7zPJNDPsFnCpLpk'),
      oraclePrices: new PublicKey('3NJYftD5sjVfxSnUdZ1wVML8f3aC6mp1CXCL6L7TnU8C'),
      programId: new PublicKey('HFn8GnPADiny6XqUoWE8uRPPxb29ikn4yTuPa9MF2fWJ'),
      configurationAccount: new PublicKey('AdTiP7QyjUyv6crF4H8z7fxJKU7Z5eCAGvJN1Y55cXxb'),
    },
    borrowing: {
      programId: new PublicKey('FAZuPmWCvPzVoSXudtMvixiGNGKyEuKvfEuJh3i6NkXu'),
      accounts: {
        stablecoinMint: new PublicKey('CkUrb2SwrriK4T7VpWjrepM4PWnfT9hwUEfz2NJmM4Hp'),
        stablecoinMintAuthority: new PublicKey('89Ecdd8J7xTycvueCuK4ML3xUheZEp917qmzKsHfCgdV'),
        hbbMintAuthority: new PublicKey('5BKFyoeZB1ZArEzq3KLxF8RhUPzBLas8kgEH5sjn16Jb'),
        borrowingVaultsV2: new PublicKey('BHgw9kZcK6LVSadiqUZYBxe8rCzTcDq1dxsJcspLmWPX'),
        borrowingMarketStates: [
          new PublicKey('YSp9bJpQom2HA7VThxYZX9pNwrcBH88NBcBNWs5yskR'),
          new PublicKey('B6gckY3KmWR2u1gwruE55Hxoj5uqiTTtuXLbE6Bu7bZq'),
        ],
        mint: {
          WSOL: new PublicKey('So11111111111111111111111111111111111111112'),
          ETH: new PublicKey('B54v6dyccBv66VBTrQHqebKpBR1UNMT6UHMWZcVKJhct'),
          BTC: new PublicKey('6Rkde5L39BoXZ9b8cGXnbTwNjLa6SmmEuZQ7vdCVbiZ7'),
          SRM: new PublicKey('ai6TJHW8RgnXdfpCgFBx7d2U53ozFeVR86cvfHK2T1w'),
          RAY: new PublicKey('6e6aWyz9viDz2yoJqSiyZVwCKp5qZx8UUzesgs3y3Emd'),
          FTT: new PublicKey('6AJ9LYjCpLFekhX7Jzq6YDQrZ72oLTeQuLgGCxHw8nq2'),
          HBB: new PublicKey('HBB111SCo9jkCejsZfz8Ec8nH7T6THF8KEKSnvwT6XK6'),
          MSOL: undefined,
          LDO: new PublicKey('HZRCwxP2Vq9PCpPXooayhJ2bxTpo5xfpQrwB1svh332p'),
          ORCA: new PublicKey('orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE'),
        },
        collateralVaultsAuthority: new PublicKey('AzrwP37zYTDh1dfbWWc3ceK2LVbijNuDvV9hS1qH96dM'),
        collateralVault: {
          SOL: new PublicKey('8CR87Meo2XbfugckHmwFbWfRnPrzqyj5dReyKdU9n4PA'),
          ETH: new PublicKey('7j92j4m7YWxWGuvjS3HNcHYRdkUp3NpkiRGTS1wdBhWm'),
          BTC: new PublicKey('CuAMwJkgvWMrkUfEoxQJWFRw8P8GtVta4HVx7DWTXDwX'),
          SRM: new PublicKey('3Z2wmrPiUHF47DrSFRZnmm4CJc9aTs3bize4QtfnGtQE'),
          RAY: new PublicKey('B1Njx94rsEAam4Am19d347t76DbxxR8pUmWLBo7MBEE'),
          FTT: new PublicKey('3xFadKYXmPUStW5UybXcmEkWrb3dBcAkhvopipKDyXd5'),
          MSOL: undefined,
        },
        redemptionsQueue: new PublicKey('DZ9nuLYkKdGmXTFUMz7FZX4EDeqkQmDL71qcivsCtHFo'),
        liquidationsQueue: new PublicKey('39NPoTCGhZ3WkZcevFX7xYyKZzYVHtvMmjsKEQpe9Ltp'),
        borrowingMarketState: new PublicKey('FiULFVsJGoi6BVQV4MZ4nRhSt5q7PMCxXhPNHedtcJK8'),
        stabilityPoolState: new PublicKey('3TahgKbYxpGp4iqtkWKy1mw8uo4FGhMzs42tgqTqcqyD'),
        epochToScaleToSum: new PublicKey('G9Ysu9DgFiUuWWWnYsRx8SvN6sfrtDY7NCaHVxgz7jeb'),
        stablecoinStabilityPoolVault: new PublicKey('21dTv2L7P52goCy4YFsM6k737yZJh3fxdL3kKtqcWCzR'),
        stabilityVaults: new PublicKey('Az4MhfSV7f7pgAnDr7UyvsiemsmrpGM39AWfkgicLawa'),
        stablecoinStabilityPoolVaultAuthority: new PublicKey('Ecg7PgFoEjX5tJw2GZN4tUKz7sh3PnSsJECcsvVkRDpq'),
        liquidationRewardsVaultSol: new PublicKey('AUznMW6M1fsGJusotrWBVHBQgNRvvucerJHVtb969Ls'),
        liquidationRewardsVaultSrm: new PublicKey('7hMX18PtEqW6z29BBCU1pWFJKoYbR3sZVZW31fD64n4y'),
        liquidationRewardsVaultEth: new PublicKey('9thYqRns8M6xXhcPTs6Ra42jt153QAjymTnU5MtHFR2F'),
        liquidationRewardsVaultBtc: new PublicKey('BxDHBQW38Wo1FgCJDbrCyYsHqpfw1gZmWCFNJbyDuf49'),
        liquidationRewardsVaultRay: new PublicKey('DuCiQJsXzXF9QKufsP8YXKqpbttaJxvx4E2LaSY4P7zz'),
        liquidationRewardsVaultFtt: new PublicKey('97Jq9TdBbKN7yxAnQMGctm7EDik7HYFTtfr4JVnSyEtS'),
        liquidationRewardsVaultAuthority: new PublicKey('FQbUdSuYtMxn9HoA649gpYVV6vh8xAiEBTHsVHm6pdAb'),
        borrowingVaults: new PublicKey('4fN86magQ4ghRfP9qfQbMnSogtJ1r6T9R7Yt7LzQSHA4'),
        globalConfig: new PublicKey('GnJoxBn17Xn5WpmUMZ2mU17TyBzLGkSxLCsczSEiHvH'),
        oracleMappings: new PublicKey('4oe3cdNdwRxv2qjXA2q4yD9aj9XdE7Yd7nBnUeunt8m7'),
        stakingPoolState: new PublicKey('8nAvRvVHAydWL743GgXMbTfXwwrPD1RDbQ69XAGG1FZy'),
        borrowingFeesAccount: new PublicKey('2pLG1oGQwFDpbCt8m8RHTWUTSKFKA56HffwESFEeFFpc'),
        borrowingFeesVaultAuthority: new PublicKey('9RXCJ66mJDcDWtNpUJknrkeda97yWLWvRnQSQjzkH2iC'),
        stakingVault: new PublicKey('D6YWbkypjqoNTUxfYZSh7ra5mD4AapHRSHRMJw8eLbn8'),
        treasuryVault: new PublicKey('4UAr1CWXFensisCGBWnSdU4dTAsa5AWtzDpYDSfbQJmc'),
        burningVault: new PublicKey('HKpANDh2zs5vChFZKse7nny9Xt5nUxqoXQahc3QrXCZ4'),
        burningVaultAuthority: new PublicKey('AbUWAzTWd1fkbV3FDzU69HJf2ntvyzUEnN5FjP5HVHhc'),
        pyth: {
          solProductInfo: new PublicKey('Bxd5yBjGL29twaLP2B1Lf6YjFFXRcUmqTz7v32BeHsTN'),
          solPriceInfo: new PublicKey('FweBx8gsTNGf1YyebZK7jPqn9SYiyptT2UUYV5pK3Scn'),
          ethProductInfo: new PublicKey('8TtUqogFv4srq3S56hVjYeyeY1Xxw4Nt9HqjDY2Pfg2Y'),
          ethPriceInfo: new PublicKey('CUug7XgabHU4X7ca7ZCesCJWnrHbK1pMCAaSxQ9RZBYo'),
          btcProductInfo: new PublicKey('7TaVKytXHEdEnG8dT6d3rf39jzY3mTrq23fYE66h1L2o'),
          btcPriceInfo: new PublicKey('ADfQ2g1DkJuTadSNW5Ssq71qd2mvmtsqv2Dn87xZx5Sb'),
          srmProductInfo: new PublicKey('Dyswi54xNFLxuTWdzah7d3HsN5dM9WQ2UTXFLfwMoZDa'),
          srmPriceInfo: new PublicKey('Covgt34sxCzsz9FS6wXss2zFmzRnsUfRbsGDuSvnNgSb'),
          rayProductInfo: new PublicKey('2gX5FKPh3kubLzHu4Pm7YMJFoWB7rx4qAdDBz5fqp1xr'),
          rayPriceInfo: new PublicKey('814AnnK8hLC3iriRGjakb1vo2tBgJknmsuG18bxauZr7'),
          fttProductInfo: new PublicKey('6U3UDYYdi7ryqgA7fs7xqK5C9coQyx1mxxvu7XzuLF95'),
          fttPriceInfo: new PublicKey('G7kqVzuayYqaCtGSZx1dJapdFWkRc18PoGaTg6Gv7z9k'),
          msolProductInfo: undefined,
          msolPriceInfo: undefined,
        },
        liquidationRewardsVaultMsol: undefined,
        USDC: undefined,
        serumMarkets: undefined,
        redemptionCandidatesQueue: undefined,
        saber: {
          stablecoinSwap: new PublicKey('MARpDPs5A7XiyCWPNH8GsMWPLxmwNn9SBmKvPa9LzgA'),
        },
      },
    },
    kaminoLending: [
      {
        lendingMarket: new PublicKey('HD6SgAR8hTjZRm54g7XLQy7auVfyFq89LX347vj1RTWv'),
        lendingMarketAuthority: new PublicKey('DFKUFHiDvHspRkvTfdGv2hCvGixKt9sN3vjHSGZxnNZX'),
        isPrimary: true,
        reserves: [
          {
            liquidityToken: {
              decimals: 9,
              symbol: 'SOL',
              mint: new PublicKey('So11111111111111111111111111111111111111112'),
            },
            address: new PublicKey('CuYZQKS1gWEB3K6NRQHYA8ftTXERQWGyV4c3zfT6TRvd'),
            collateralMint: new PublicKey('C658y9dHBiadsycj2mT6knGrya9JjceJfgwEG5qyZWKu'),
            collateralSupply: new PublicKey('8fNz4sAduikZYyrf19Y75zbPQxeea4yRPzQLRr3WoSdv'),
            liquiditySupply: new PublicKey('4EWNVRjAyBV65LnUuuNxY9CHs2cJ3fYWZnw3yEFTNMC6'),
            liquidityFeeReceiverAddress: new PublicKey('HEELm1ZsQAaypfS1fQ6UXFFznX9VQ6S3KrYf6uBYkauv'),
            pythOracle: new PublicKey('J83w4HKfqxwcq3BEMMkPFSppX3gqekLyLJBexebFVkix'),
            switchboardOracle: new PublicKey('nu11111111111111111111111111111111111111111'),
          },
          {
            liquidityToken: {
              decimals: 6,
              symbol: 'USDH',
              mint: new PublicKey('HWzkNyXynnC3mAZAL4yKZNvWs3SwS9eBVKdzmKcxYHSH'),
            },
            address: new PublicKey('41AnqvAYzvaSHYv1PCqmfp7f2wqRXKJPF4hHgLicHrDQ'),
            collateralMint: new PublicKey('3hrRVdDiqhdspB8KYHRnCMo97HabVHKstg25c1njyWKk'),
            collateralSupply: new PublicKey('8eHxnQ5mj9wfn4dzLLmaz5c829WHprFhAMse3Jrrjo1R'),
            liquiditySupply: new PublicKey('A9fNepK75rEVPoPk3b4nRpvrbRaVHbCth4D1rEcfZWZc'),
            liquidityFeeReceiverAddress: new PublicKey('8hyZAriFUqt53Qaz8qKFzjHxMcu2wvQSuXR8aN6Zpuc'),
            pythOracle: new PublicKey('nu11111111111111111111111111111111111111111'),
            switchboardOracle: new PublicKey('DahMqw2Gue2EnnKkeyHmqVMbF1vz31CoCsabnBTo3fif'),
          },
          {
            liquidityToken: {
              decimals: 6,
              symbol: 'USDC',
              mint: new PublicKey('8KinRubdHLTivgyS6kv5Rph7kkMv5sdCroTSXNeq1sWq'),
            },
            address: new PublicKey('GqynGfQuVb9x9ji2aGngqnbXoeydS9i3JSrdxzAkLUr4'),
            collateralMint: new PublicKey('T24csPyVhNpVYPjQhVhVp5eP6VvAFzLg9LzGAvSiCJu'),
            collateralSupply: new PublicKey('RAALczeSmQddb5yTjguXiApUqNCQoDxYQHp6FT5LxeB'),
            liquiditySupply: new PublicKey('GaLu9KD3boE2Rzg1oRfrpHnWf7uVjj1yHiaV37xqVWfg'),
            liquidityFeeReceiverAddress: new PublicKey('Dq6Rgr261Zs3Yj9ewNMq7nJq4BnZLPrevtsVFGdxb5Rk'),
            pythOracle: new PublicKey('38xoQ4oeJCBrcVvca2cGk7iV1dAfrmTR1kmhSCJQ8Jto'),
            switchboardOracle: new PublicKey('nu11111111111111111111111111111111111111111'),
          },
          {
            liquidityToken: {
              decimals: 9,
              symbol: 'STSOL',
              mint: new PublicKey('G89c7G8YkQQGP3hyPHM2Jn3x2xn5zKZRPspCwVMfzsMT'),
            },
            address: new PublicKey('49bVSGTN7tcYMqgNNRFGfcg8wNcF8ssQmrwouS6wsxvc'),
            collateralMint: new PublicKey('44qBTX95d1pGGkqndiUUGE3ZTNCKsEA5PtPo3ztNhnvN'),
            collateralSupply: new PublicKey('DJ1oMSZRoJzT5g4TNu7SM8YwS96E5h2NFMVXRBxo5yns'),
            liquiditySupply: new PublicKey('6KutGfsMK7w6BRJKWBkebpyuN7dEASn85oui79eJY4NY'),
            liquidityFeeReceiverAddress: new PublicKey('HRmB1VE6KHw1EvtXY7N3yzfXm3GZt489ZdpP5DKmbq4i'),
            pythOracle: new PublicKey('2LwhbcswZekofMNRtDRMukZJNSRUiKYMFbqtBwqjDfke'),
            switchboardOracle: new PublicKey('9LNYQZLJG5DAyeACCTzBFG6H3sDhehP5xtYLdhrZtQkA'),
          },
          {
            liquidityToken: {
              decimals: 6,
              symbol: 'kUSDHUSDCOrca',
              mint: new PublicKey('E8KG1XTQE3bf6ZTDG7xa38PAbAxHaDumsAgmGraY58MQ'),
            },
            address: new PublicKey('HW65CmnrphRxMDg2YRsQJwdMc8tSzzMpdDawmdvkwGMt'),
            collateralMint: new PublicKey('9hEo8mpuKf2UNjcWvPyTWiS67SbFigNdiJZnQL5VnCFq'),
            collateralSupply: new PublicKey('146ssPwPSmMwHSekGo1NefAcDnCMuLbuANDbv1o49ii3'),
            liquiditySupply: new PublicKey('55jcYQPxC9Umd8neAvLPyuhQj5kZ3D9GjcYhNju6J1z7'),
            liquidityFeeReceiverAddress: new PublicKey('rYi1vnpsgAjJsxvjtzLpUW7xCqgUjsKYj56piibRLo3'),
            pythOracle: new PublicKey('nu11111111111111111111111111111111111111111'),
            switchboardOracle: new PublicKey('CTLRyAao68yqeid6i2xbiY8w3XXLrNqe23eWH1iUWmxH'),
          },
        ],
      },
    ],
  },
];
